"use strict";

/*! dprd-semantic-analytics-framework - v4.0.37 - 2017-07-19 */
(function (window, undefined) {
  /*! wdpro-sitecatalyst - v5.3.11-0 - 2017-07-11 */
  (function () {
    /*
     ============== LOOK BELOW THIS BLOCK OF CODE FOR VISITOR API CONFIG ! ============
    
     Adobe Visitor API for JavaScript version: 1.5.7
     Copyright 1996-2015 Adobe, Inc. All Rights Reserved
     More info available at http://www.omniture.com
    */
    window.Visitor = Visitor;
    function Visitor(m, t) {
      if (!m) throw "Visitor requires Adobe Marketing Cloud Org ID";var a = this;a.version = "1.5.7";var l = window,
          i = l.Visitor;i.version = a.version;l.s_c_in || (l.s_c_il = [], l.s_c_in = 0);a._c = "Visitor";a._il = l.s_c_il;a._in = l.s_c_in;a._il[a._in] = a;l.s_c_in++;a.pa = { Ka: [] };var o = l.document,
          h = i.Ma;h || (h = null);var z = i.Na;z || (z = void 0);var j = i.ja;j || (j = !0);var k = i.La;k || (k = !1);a.S = function (a) {
        var c = 0,
            b,
            e;if (a) for (b = 0; b < a.length; b++) {
          e = a.charCodeAt(b), c = (c << 5) - c + e, c &= c;
        }return c;
      };a.r = function (a) {
        var c = "0123456789",
            b = "",
            e = "",
            f,
            g = 8,
            n = 10,
            h = 10;if (1 == a) {
          c += "ABCDEF";for (a = 0; 16 > a; a++) {
            f = Math.floor(Math.random() * g), b += c.substring(f, f + 1), f = Math.floor(Math.random() * g), e += c.substring(f, f + 1), g = 16;
          }return b + "-" + e;
        }for (a = 0; 19 > a; a++) {
          f = Math.floor(Math.random() * n), b += c.substring(f, f + 1), 0 == a && 9 == f ? n = 3 : (1 == a || 2 == a) && 10 != n && 2 > f ? n = 10 : 2 < a && (n = 10), f = Math.floor(Math.random() * h), e += c.substring(f, f + 1), 0 == a && 9 == f ? h = 3 : (1 == a || 2 == a) && 10 != h && 2 > f ? h = 10 : 2 < a && (h = 10);
        }return b + e;
      };a.ma = function () {
        var a;!a && l.location && (a = l.location.hostname);
        if (a) if (/^[0-9.]+$/.test(a)) a = "";else {
          var c = a.split("."),
              b = c.length - 1,
              e = b - 1;1 < b && 2 >= c[b].length && (2 == c[b - 1].length || 0 > ",ac,ad,ae,af,ag,ai,al,am,an,ao,aq,ar,as,at,au,aw,ax,az,ba,bb,be,bf,bg,bh,bi,bj,bm,bo,br,bs,bt,bv,bw,by,bz,ca,cc,cd,cf,cg,ch,ci,cl,cm,cn,co,cr,cu,cv,cw,cx,cz,de,dj,dk,dm,do,dz,ec,ee,eg,es,et,eu,fi,fm,fo,fr,ga,gb,gd,ge,gf,gg,gh,gi,gl,gm,gn,gp,gq,gr,gs,gt,gw,gy,hk,hm,hn,hr,ht,hu,id,ie,im,in,io,iq,ir,is,it,je,jo,jp,kg,ki,km,kn,kp,kr,ky,kz,la,lb,lc,li,lk,lr,ls,lt,lu,lv,ly,ma,mc,md,me,mg,mh,mk,ml,mn,mo,mp,mq,mr,ms,mt,mu,mv,mw,mx,my,na,nc,ne,nf,ng,nl,no,nr,nu,nz,om,pa,pe,pf,ph,pk,pl,pm,pn,pr,ps,pt,pw,py,qa,re,ro,rs,ru,rw,sa,sb,sc,sd,se,sg,sh,si,sj,sk,sl,sm,sn,so,sr,st,su,sv,sx,sy,sz,tc,td,tf,tg,th,tj,tk,tl,tm,tn,to,tp,tr,tt,tv,tw,tz,ua,ug,uk,us,uy,uz,va,vc,ve,vg,vi,vn,vu,wf,ws,yt,".indexOf("," + c[b] + ",")) && e--;if (0 < e) for (a = ""; b >= e;) {
            a = c[b] + (a ? "." : "") + a, b--;
          }
        }return a;
      };a.cookieRead = function (a) {
        var a = encodeURIComponent(a),
            c = (";" + o.cookie).split(" ").join(";"),
            b = c.indexOf(";" + a + "="),
            e = 0 > b ? b : c.indexOf(";", b + 1);return 0 > b ? "" : decodeURIComponent(c.substring(b + 2 + a.length, 0 > e ? c.length : e));
      };a.cookieWrite = function (d, c, b) {
        var e = a.cookieLifetime,
            f,
            c = "" + c,
            e = e ? ("" + e).toUpperCase() : "";b && "SESSION" != e && "NONE" != e ? (f = "" != c ? parseInt(e ? e : 0, 10) : -60) ? (b = new Date(), b.setTime(b.getTime() + 1E3 * f)) : 1 == b && (b = new Date(), f = b.getYear(), b.setYear(f + 2 + (1900 > f ? 1900 : 0))) : b = 0;return d && "NONE" != e ? (o.cookie = encodeURIComponent(d) + "=" + encodeURIComponent(c) + "; path=/;" + (b ? " expires=" + b.toGMTString() + ";" : "") + (a.cookieDomain ? " domain=" + a.cookieDomain + ";" : ""), a.cookieRead(d) == c) : 0;
      };a.g = h;a.A = function (a, c) {
        try {
          "function" == typeof a ? a.apply(l, c) : a[1].apply(a[0], c);
        } catch (b) {}
      };a.ra = function (d, c) {
        c && (a.g == h && (a.g = {}), a.g[d] == z && (a.g[d] = []), a.g[d].push(c));
      };a.m = function (d, c) {
        if (a.g != h) {
          var b = a.g[d];if (b) for (; 0 < b.length;) {
            a.A(b.shift(), c);
          }
        }
      };a.j = h;a.oa = function (d, c, b) {
        var e = 0,
            f = 0,
            g;if (c && o) {
          for (g = 0; !e && 2 > g;) {
            try {
              e = (e = o.getElementsByTagName(0 < g ? "HEAD" : "head")) && 0 < e.length ? e[0] : 0;
            } catch (n) {
              e = 0;
            }g++;
          }if (!e) try {
            o.body && (e = o.body);
          } catch (j) {
            e = 0;
          }if (e) for (g = 0; !f && 2 > g;) {
            try {
              f = o.createElement(0 < g ? "SCRIPT" : "script");
            } catch (i) {
              f = 0;
            }g++;
          }
        }!c || !e || !f ? b && b() : (f.type = "text/javascript", f.setAttribute("async", "async"), f.src = c, e.firstChild ? e.insertBefore(f, e.firstChild) : e.appendChild(f), a.pa.Ka.push(c), b && (a.j == h && (a.j = {}), a.j[d] = setTimeout(b, a.loadTimeout)));
      };
      a.ka = function (d) {
        a.j != h && a.j[d] && (clearTimeout(a.j[d]), a.j[d] = 0);
      };a.T = k;a.U = k;a.isAllowed = function () {
        if (!a.T && (a.T = j, a.cookieRead(a.cookieName) || a.cookieWrite(a.cookieName, "T", 1))) a.U = j;return a.U;
      };a.a = h;a.d = h;var B = i.$a;B || (B = "MC");var s = i.fb;s || (s = "MCMID");var C = i.ab;C || (C = "MCCIDH");var D = i.eb;D || (D = "MCSYNCS");var F = i.bb;F || (F = "MCIDTS");var x = i.cb;x || (x = "MCOPTOUT");var A = i.Ya;A || (A = "A");var p = i.Va;p || (p = "MCAID");var y = i.Za;y || (y = "AAM");var w = i.Xa;w || (w = "MCAAMLH");var q = i.Wa;q || (q = "MCAAMB");var r = i.gb;r || (r = "NONE");a.C = 0;a.R = function () {
        if (!a.C) {
          var d = a.version;a.audienceManagerServer && (d += "|" + a.audienceManagerServer);a.audienceManagerServerSecure && (d += "|" + a.audienceManagerServerSecure);a.C = a.S(d);
        }return a.C;
      };a.V = k;a.f = function () {
        if (!a.V) {
          a.V = j;var d = a.R(),
              c = k,
              b = a.cookieRead(a.cookieName),
              e,
              f,
              g,
              n,
              i = new Date();a.a == h && (a.a = {});if (b && "T" != b) {
            b = b.split("|");b[0].match(/^[\-0-9]+$/) && (parseInt(b[0], 10) != d && (c = j), b.shift());1 == b.length % 2 && b.pop();for (d = 0; d < b.length; d += 2) {
              if (e = b[d].split("-"), f = e[0], g = b[d + 1], 1 < e.length ? (n = parseInt(e[1], 10), e = 0 < e[1].indexOf("s")) : (n = 0, e = k), c && (f == C && (g = ""), 0 < n && (n = i.getTime() / 1E3 - 60)), f && g && (a.c(f, g, 1), 0 < n && (a.a["expire" + f] = n + (e ? "s" : ""), i.getTime() >= 1E3 * n || e && !a.cookieRead(a.sessionCookieName)))) a.d || (a.d = {}), a.d[f] = j;
            }
          }if (!a.b(p) && (b = a.cookieRead("s_vi"))) b = b.split("|"), 1 < b.length && 0 <= b[0].indexOf("v1") && (g = b[1], d = g.indexOf("["), 0 <= d && (g = g.substring(0, d)), g && g.match(/^[0-9a-fA-F\-]+$/) && a.c(p, g));
        }
      };a.ta = function () {
        var d = a.R(),
            c,
            b;for (c in a.a) {
          !Object.prototype[c] && a.a[c] && "expire" != c.substring(0, 6) && (b = a.a[c], d += (d ? "|" : "") + c + (a.a["expire" + c] ? "-" + a.a["expire" + c] : "") + "|" + b);
        }a.cookieWrite(a.cookieName, d, 1);
      };a.b = function (d, c) {
        return a.a != h && (c || !a.d || !a.d[d]) ? a.a[d] : h;
      };a.c = function (d, c, b) {
        a.a == h && (a.a = {});a.a[d] = c;b || a.ta();
      };a.na = function (d, c) {
        var b = a.b(d, c);return b ? b.split("*") : h;
      };a.sa = function (d, c, b) {
        a.c(d, c ? c.join("*") : "", b);
      };a.Sa = function (d, c) {
        var b = a.na(d, c);if (b) {
          var e = {},
              f;for (f = 0; f < b.length; f += 2) {
            e[b[f]] = b[f + 1];
          }return e;
        }return h;
      };a.Ua = function (d, c, b) {
        var e = h,
            f;if (c) for (f in e = [], c) {
          Object.prototype[f] || (e.push(f), e.push(c[f]));
        }a.sa(d, e, b);
      };a.k = function (d, c, b) {
        var e = new Date();e.setTime(e.getTime() + 1E3 * c);a.a == h && (a.a = {});a.a["expire" + d] = Math.floor(e.getTime() / 1E3) + (b ? "s" : "");0 > c ? (a.d || (a.d = {}), a.d[d] = j) : a.d && (a.d[d] = k);b && (a.cookieRead(a.sessionCookieName) || a.cookieWrite(a.sessionCookieName, "1"));
      };a.Q = function (a) {
        if (a && ("object" == typeof a && (a = a.d_mid ? a.d_mid : a.visitorID ? a.visitorID : a.id ? a.id : a.uuid ? a.uuid : "" + a), a && (a = a.toUpperCase(), "NOTARGET" == a && (a = r)), !a || a != r && !a.match(/^[0-9a-fA-F\-]+$/))) a = "";return a;
      };a.i = function (d, c) {
        a.ka(d);a.h != h && (a.h[d] = k);if (d == B) {
          var b = a.b(s);if (!b) {
            b = "object" == typeof c && c.mid ? c.mid : a.Q(c);if (!b) {
              if (a.v) {
                a.getAnalyticsVisitorID(h, k, j);return;
              }b = a.r();
            }a.c(s, b);
          }if (!b || b == r) b = "";"object" == typeof c && ((c.d_region || c.dcs_region || c.d_blob || c.blob) && a.i(y, c), a.v && c.mid && a.i(A, { id: c.id }));a.m(s, [b]);
        }if (d == y && "object" == typeof c) {
          b = 604800;c.id_sync_ttl != z && c.id_sync_ttl && (b = parseInt(c.id_sync_ttl, 10));var e = a.b(w);e || ((e = c.d_region) || (e = c.dcs_region), e && (a.k(w, b), a.c(w, e)));e || (e = "");a.m(w, [e]);e = a.b(q);if (c.d_blob || c.blob) (e = c.d_blob) || (e = c.blob), a.k(q, b), a.c(q, e);e || (e = "");a.m(q, [e]);!c.error_msg && a.t && a.c(C, a.t);
        }if (d == A) {
          b = a.b(p);b || ((b = a.Q(c)) ? b !== r && a.k(q, -1) : b = r, a.c(p, b));if (!b || b == r) b = "";a.m(p, [b]);
        }a.idSyncDisableSyncs ? u.ba = j : (u.ba = k, b = {}, b.ibs = c.ibs, b.subdomain = c.subdomain, u.Ia(b));c === Object(c) && (b = r, c.d_optout && c.d_optout instanceof Array && (b = c.d_optout.join(",")), e = parseInt(c.d_ottl, 10), isNaN(e) && (e = 7200), a.k(x, e, !0), a.c(x, b), a.m(x, [b]));
      };a.h = h;a.n = function (d, c, b, e) {
        var f = "",
            g;if (a.isAllowed() && (a.f(), f = a.b(d), !f && (d == s || d == x ? g = B : d == w || d == q ? g = y : d == p && (g = A), g))) {
          if (c && (a.h == h || !a.h[g])) a.h == h && (a.h = {}), a.h[g] = j, a.oa(g, c, function () {
            if (!a.b(d)) {
              var b = "";d == s ? b = a.r() : g == y && (b = { error_msg: "timeout" });a.i(g, b);
            }
          });a.ra(d, b);c || a.i(g, { id: r });return "";
        }if ((d == s || d == p) && f == r) f = "", e = j;b && e && a.A(b, [f]);return f;
      };a._setMarketingCloudFields = function (d) {
        a.f();a.i(B, d);
      };a.setMarketingCloudVisitorID = function (d) {
        a._setMarketingCloudFields(d);
      };
      a.v = k;a.getMarketingCloudVisitorID = function (d, c) {
        if (a.isAllowed()) {
          a.marketingCloudServer && 0 > a.marketingCloudServer.indexOf(".demdex.net") && (a.v = j);var b = a.s("_setMarketingCloudFields");return a.n(s, b, d, c);
        }return "";
      };a.qa = function () {
        a.getAudienceManagerBlob();
      };i.AuthState = { UNKNOWN: 0, AUTHENTICATED: 1, LOGGED_OUT: 2 };a.q = {};a.P = k;a.t = "";a.setCustomerIDs = function (d) {
        if (a.isAllowed() && d) {
          a.f();var c, b;for (c in d) {
            if (!Object.prototype[c] && (b = d[c])) if ("object" == typeof b) {
              var e = {};b.id && (e.id = b.id);b.authState != z && (e.authState = b.authState);a.q[c] = e;
            } else a.q[c] = { id: b };
          }var d = a.getCustomerIDs(),
              e = a.b(C),
              f = "";e || (e = 0);for (c in d) {
            Object.prototype[c] || (b = d[c], f += (f ? "|" : "") + c + "|" + (b.id ? b.id : "") + (b.authState ? b.authState : ""));
          }a.t = a.S(f);a.t != e && (a.P = j, a.qa());
        }
      };a.getCustomerIDs = function () {
        a.f();var d = {},
            c,
            b;for (c in a.q) {
          Object.prototype[c] || (b = a.q[c], d[c] || (d[c] = {}), b.id && (d[c].id = b.id), d[c].authState = b.authState != z ? b.authState : i.AuthState.UNKNOWN);
        }return d;
      };a._setAnalyticsFields = function (d) {
        a.f();a.i(A, d);
      };a.setAnalyticsVisitorID = function (d) {
        a._setAnalyticsFields(d);
      };a.getAnalyticsVisitorID = function (d, c, b) {
        if (a.isAllowed()) {
          var e = "";b || (e = a.getMarketingCloudVisitorID(function () {
            a.getAnalyticsVisitorID(d, j);
          }));if (e || b) {
            var f = b ? a.marketingCloudServer : a.trackingServer,
                g = "";a.loadSSL && (b ? a.marketingCloudServerSecure && (f = a.marketingCloudServerSecure) : a.trackingServerSecure && (f = a.trackingServerSecure));f && (g = "http" + (a.loadSSL ? "s" : "") + "://" + f + "/id?d_visid_ver=" + a.version + "&callback=s_c_il%5B" + a._in + "%5D._set" + (b ? "MarketingCloud" : "Analytics") + "Fields&mcorgid=" + encodeURIComponent(a.marketingCloudOrgID) + (e ? "&mid=" + encodeURIComponent(e) : "") + (a.idSyncDisable3rdPartySyncing ? "&d_coppa=true" : ""));return a.n(b ? s : p, g, d, c);
          }
        }return "";
      };a._setAudienceManagerFields = function (d) {
        a.f();a.i(y, d);
      };a.s = function (d) {
        var c = a.audienceManagerServer,
            b = "",
            e = a.b(s),
            f = a.b(q, j),
            g = a.b(p),
            g = g && g != r ? "&d_cid_ic=AVID%01" + encodeURIComponent(g) : "";a.loadSSL && a.audienceManagerServerSecure && (c = a.audienceManagerServerSecure);if (c) {
          var b = a.getCustomerIDs(),
              h,
              i;if (b) for (h in b) {
            Object.prototype[h] || (i = b[h], g += "&d_cid_ic=" + encodeURIComponent(h) + "%01" + encodeURIComponent(i.id ? i.id : "") + (i.authState ? "%01" + i.authState : ""));
          }d || (d = "_setAudienceManagerFields");b = "http" + (a.loadSSL ? "s" : "") + "://" + c + "/id?d_visid_ver=" + a.version + "&d_rtbd=json&d_ver=2" + (!e && a.v ? "&d_verify=1" : "") + "&d_orgid=" + encodeURIComponent(a.marketingCloudOrgID) + "&d_nsid=" + (a.idSyncContainerID || 0) + (e ? "&d_mid=" + encodeURIComponent(e) : "") + (a.idSyncDisable3rdPartySyncing ? "&d_coppa=true" : "") + (f ? "&d_blob=" + encodeURIComponent(f) : "") + g + "&d_cb=s_c_il%5B" + a._in + "%5D." + d;
        }return b;
      };a.getAudienceManagerLocationHint = function (d, c) {
        if (a.isAllowed() && a.getMarketingCloudVisitorID(function () {
          a.getAudienceManagerLocationHint(d, j);
        })) {
          var b = a.b(p);b || (b = a.getAnalyticsVisitorID(function () {
            a.getAudienceManagerLocationHint(d, j);
          }));if (b) return b = a.s(), a.n(w, b, d, c);
        }return "";
      };a.getAudienceManagerBlob = function (d, c) {
        if (a.isAllowed() && a.getMarketingCloudVisitorID(function () {
          a.getAudienceManagerBlob(d, j);
        })) {
          var b = a.b(p);b || (b = a.getAnalyticsVisitorID(function () {
            a.getAudienceManagerBlob(d, j);
          }));if (b) return b = a.s(), a.P && a.k(q, -1), a.n(q, b, d, c);
        }return "";
      };a.o = "";a.u = {};a.D = "";a.F = {};a.getSupplementalDataID = function (d, c) {
        !a.o && !c && (a.o = a.r(1));var b = a.o;a.D && !a.F[d] ? (b = a.D, a.F[d] = j) : b && (a.u[d] && (a.D = a.o, a.F = a.u, a.o = b = !c ? a.r(1) : "", a.u = {}), b && (a.u[d] = j));return b;
      };i.OptOut = { GLOBAL: "global" };a.getOptOut = function (d, c) {
        if (a.isAllowed()) {
          var b = a.s("_setMarketingCloudFields");return a.n(x, b, d, c);
        }return "";
      };a.isOptedOut = function (d, c, b) {
        return a.isAllowed() ? (c || (c = i.OptOut.GLOBAL), (b = a.getOptOut(function (b) {
          a.A(d, [b == i.OptOut.GLOBAL || 0 <= b.indexOf(c)]);
        }, b)) ? b == i.OptOut.GLOBAL || 0 <= b.indexOf(c) : h) : k;
      };var v = { l: !!l.postMessage, ha: 1, O: 864E5 };a.Oa = v;a.X = { postMessage: function postMessage(a, c, b) {
          var e = 1;c && (v.l ? b.postMessage(a, c.replace(/([^:]+:\/\/[^\/]+).*/, "$1")) : c && (b.location = c.replace(/#.*$/, "") + "#" + +new Date() + e++ + "&" + a));
        }, K: function K(a, c) {
          var b;try {
            if (v.l) if (a && (b = function b(_b) {
              if ("string" === typeof c && _b.origin !== c || "[object Function]" === Object.prototype.toString.call(c) && !1 === c(_b.origin)) return !1;a(_b);
            }), window.addEventListener) window[a ? "addEventListener" : "removeEventListener"]("message", b, !1);else window[a ? "attachEvent" : "detachEvent"]("onmessage", b);
          } catch (e) {}
        } };var G = { Y: function () {
          if (o.addEventListener) return function (a, c, b) {
            a.addEventListener(c, function (a) {
              "function" === typeof b && b(a);
            }, k);
          };if (o.attachEvent) return function (a, c, b) {
            a.attachEvent("on" + c, function (a) {
              "function" === typeof b && b(a);
            });
          };
        }(), map: function map(a, c) {
          if (Array.prototype.map) return a.map(c);if (void 0 === a || a === h) throw new TypeError();var b = Object(a),
              e = b.length >>> 0;if ("function" !== typeof c) throw new TypeError();for (var f = Array(e), g = 0; g < e; g++) {
            g in b && (f[g] = c.call(c, b[g], g, b));
          }return f;
        }, za: function za(a, c) {
          return this.map(a, function (a) {
            return encodeURIComponent(a);
          }).join(c);
        } };a.Ta = G;var u = { ia: 3E4, N: 649, fa: k, id: h, I: h, aa: function aa(a) {
          if ("string" === typeof a) return a = a.split("/"), a[0] + "//" + a[2];
        }, e: h, url: h, Aa: function Aa() {
          var d = "http://fast.",
              c = "?d_nsid=" + a.idSyncContainerID + "#" + encodeURIComponent(o.location.href);this.e || (this.e = "nosubdomainreturned");a.loadSSL && (d = a.idSyncSSLUseAkamai ? "https://fast." : "https://");d = d + this.e + ".demdex.net/dest5.html" + c;this.I = this.aa(d);this.id = "destination_publishing_iframe_" + this.e + "_" + a.idSyncContainerID;return d;
        }, va: function va() {
          var d = "?d_nsid=" + a.idSyncContainerID + "#" + encodeURIComponent(o.location.href);"string" === typeof a.B && a.B.length && (this.id = "destination_publishing_iframe_" + new Date().getTime() + "_" + a.idSyncContainerID, this.I = this.aa(a.B), this.url = a.B + d);
        }, ba: h, H: k, M: k, w: h, hb: h, Ga: h, ib: h, L: k, z: [], Ea: [], Fa: [], ca: v.l ? 15 : 100, J: [], Ca: [], $: j, da: k,
        Z: function Z() {
          function a() {
            e = document.createElement("iframe");e.sandbox = "allow-scripts allow-same-origin";e.id = b.id;e.style.cssText = "display: none; width: 0; height: 0;";e.src = b.url;b.Ga = j;c();document.body.appendChild(e);
          }function c() {
            G.Y(e, "load", function () {
              e.className = "aamIframeLoaded";b.w = j;b.p();
            });
          }this.M = j;var b = this,
              e = document.getElementById(this.id);e ? "IFRAME" !== e.nodeName ? (this.id += "_2", a()) : "aamIframeLoaded" !== e.className ? c() : (this.w = j, this.p()) : a();this.Ba = e;
        }, p: function p(d) {
          var c = this;d === Object(d) && this.J.push(d);if ((this.da || !v.l || this.w) && this.J.length) this.Ha(this.J.shift()), this.p();!a.idSyncDisableSyncs && this.w && this.z.length && !this.L && (this.fa || (this.fa = j, setTimeout(function () {
            c.ca = v.l ? 15 : 150;
          }, this.ia)), this.L = j, this.ea());
        }, Ha: function Ha(a) {
          var c = encodeURIComponent,
              b,
              e,
              f,
              g,
              h;if ((b = a.ibs) && b instanceof Array && (e = b.length)) for (f = 0; f < e; f++) {
            g = b[f], h = [c("ibs"), c(g.id || ""), c(g.tag || ""), G.za(g.url || [], ","), c(g.ttl || ""), "", "", g.fireURLSync ? "true" : "false"], this.$ ? this.G(h.join("|")) : g.fireURLSync && this.wa(g, h.join("|"));
          }this.Ca.push(a);
        }, wa: function wa(d, c) {
          a.f();var b = a.b(D),
              e = k,
              f = k,
              g = Math.ceil(new Date().getTime() / v.O);if (b) {
            if (b = b.split("*"), f = this.Ja(b, d.id, g), e = f.xa, f = f.ya, !e || !f) this.G(c), b.push(d.id + "-" + (g + Math.ceil(d.ttl / 60 / 24))), this.Da(b), a.c(D, b.join("*"));
          } else this.G(c), a.c(D, d.id + "-" + (g + Math.ceil(d.ttl / 60 / 24)));
        }, Ja: function Ja(a, c, b) {
          var e = k,
              f = k,
              g,
              h,
              i;for (h = 0; h < a.length; h++) {
            g = a[h], i = parseInt(g.split("-")[1], 10), g.match("^" + c + "-") ? (e = j, b < i ? f = j : (a.splice(h, 1), h--)) : b >= i && (a.splice(h, 1), h--);
          }return { xa: e, ya: f };
        }, Da: function Da(a) {
          if (a.join("*").length > this.N) for (a.sort(function (a, b) {
            return parseInt(a.split("-")[1], 10) - parseInt(b.split("-")[1], 10);
          }); a.join("*").length > this.N;) {
            a.shift();
          }
        }, G: function G(d) {
          var c = encodeURIComponent;this.z.push((a.Qa ? c("---destpub-debug---") : c("---destpub---")) + d);
        }, ea: function ea() {
          var d = this,
              c;this.z.length ? (c = this.z.shift(), a.X.postMessage(c, this.url, this.Ba.contentWindow), this.Ea.push(c), setTimeout(function () {
            d.ea();
          }, this.ca)) : this.L = k;
        }, K: function K(a) {
          var c = /^---destpub-to-parent---/;
          "string" === typeof a && c.test(a) && (c = a.replace(c, "").split("|"), "canSetThirdPartyCookies" === c[0] && (this.$ = "true" === c[1] ? j : k, this.da = j, this.p()), this.Fa.push(a));
        }, Ia: function Ia(d) {
          this.url === h && (this.e = "string" === typeof a.W && a.W.length ? a.W : d.subdomain || "", this.url = this.Aa());d.ibs instanceof Array && d.ibs.length && (this.H = j);if (!a.idSyncDisable3rdPartySyncing && (this.H || a.la) && this.e && "nosubdomainreturned" !== this.e && !this.M) (i.ga || "complete" === o.readyState || "loaded" === o.readyState) && this.Z();"function" === typeof a.idSyncIDCallResult ? a.idSyncIDCallResult(d) : this.p(d);"function" === typeof a.idSyncAfterIDCallResult && a.idSyncAfterIDCallResult(d);
        }, ua: function ua(d, c) {
          return a.Ra || !d || c - d > v.ha;
        } };a.Pa = u;0 > m.indexOf("@") && (m += "@AdobeOrg");a.marketingCloudOrgID = m;a.cookieName = "AMCV_" + m;a.sessionCookieName = "AMCVS_" + m;a.cookieDomain = a.ma();a.cookieDomain == l.location.hostname && (a.cookieDomain = "");a.loadSSL = 0 <= l.location.protocol.toLowerCase().indexOf("https");a.loadTimeout = 500;a.marketingCloudServer = a.audienceManagerServer = "dpm.demdex.net";if (t && "object" == typeof t) {
        for (var E in t) {
          !Object.prototype[E] && (a[E] = t[E]);
        }a.idSyncContainerID = a.idSyncContainerID || 0;a.f();E = a.b(F);var H = Math.ceil(new Date().getTime() / v.O);!a.idSyncDisableSyncs && u.ua(E, H) && (a.k(q, -1), a.c(F, H));a.getMarketingCloudVisitorID();a.getAudienceManagerLocationHint();a.getAudienceManagerBlob();
      }if (!a.idSyncDisableSyncs) {
        u.va();G.Y(window, "load", function () {
          var d = u;i.ga = j;!a.idSyncDisable3rdPartySyncing && (d.H || a.la) && d.e && "nosubdomainreturned" !== d.e && d.url && !d.M && d.Z();
        });try {
          a.X.K(function (a) {
            u.K(a.data);
          }, u.I);
        } catch (I) {}
      }
    }Visitor.getInstance = function (m, t) {
      var a,
          l = window.s_c_il,
          i;0 > m.indexOf("@") && (m += "@AdobeOrg");if (l) for (i = 0; i < l.length; i++) {
        if ((a = l[i]) && "Visitor" == a._c && a.marketingCloudOrgID == m) return a;
      }return new Visitor(m, t);
    };(function () {
      function m() {
        t.ga = a;
      }var t = window.Visitor,
          a = t.ja;a || (a = !0);window.addEventListener ? window.addEventListener("load", m) : window.attachEvent && window.attachEvent("onload", m);
    })();

    /**** VISITOR API CONFIG ****/

    var AdobeMarketingCloudId = "EDA101AC512D2B230A490D4C@AdobeOrg",
        visitor = Visitor.getInstance(AdobeMarketingCloudId, {
      trackingServer: window.visitorServiceTrackingServer || 'w88.go.com', // same as s.trackingServer
      trackingServerSecure: window.visitorServiceTrackingServerSecure || 'sw88.go.com', //same as s.trackingServerSecure

      // To enable CNAME support, add the following configuration variables
      // If you are not using CNAME, DO NOT include these variables
      marketingCloudServer: window.visitorServiceMarketingCloudServer || 'w88.go.com',
      marketingCloudServerSecure: window.visitorServiceMarketingCloudServerSecure || 'sw88.go.com', //same as s.trackingServerSecure
      cookieDomain: window.visitorServiceCookieDomain || undefined,
      cookieLifetime: window.visitorServiceCookieLifetime || undefined,
      idSyncAttachIframeASAP: true
    });

    (function (visitor) {
      var SWID = visitor.cookieRead('SWID'),
          loggedInPattern = /\{.+\}/i;

      if (SWID && SWID.match(loggedInPattern)) {
        visitor.setCustomerIDs({
          AdobeCampaignID: {
            id: SWID,
            authState: Visitor.AuthState.AUTHENTICATED
          }
        });
      }
    })(visitor);

    [["AdobeMarketingCloudId", AdobeMarketingCloudId], ["Visitor", Visitor], ["visitor", visitor]].forEach(function (arr) {
      window[arr[0]] = arr[1];
    });
  })();
  (function () {
    var mboxCopyright = "Copyright 1996-2015. Adobe Systems Incorporated. All rights reserved.";

    /* WDPRO Additions */
    var tnt_wdpro = {
      aMboxTargets: [],
      // tnt_wdpro.aMboxTargets Hashmap [strMboxName: nodeMBoxElement]
      aMboxTargetsState: [],
      aMboxes: [],
      seenCmpCookie: 'wdpro_seen_cmps',
      // getElement
      // @desciption returns an element via a selector, such as 'jQuery(".home-panel > .bd div:nth-child(4)").get(0)', or by element id
      // @param strTarget Either a query or an element id
      getElement: function getElement(strTarget) {
        if (strTarget) {
          if (strTarget.indexOf('(') > -1) {
            return new Function('return ' + strTarget)();
          } else {
            return document.getElementById(strTarget);
          }
        } else {
          return false;
        }
      },
      showMboxTargetDivs: function showMboxTargetDivs(strMboxName, nodeTarget) {
        if (nodeTarget && typeof nodeTarget === 'object') {
          tnt_wdpro.aMboxTargetsState[strMboxName] = 'visible';
          nodeTarget.style.visibility = 'visible';
        }
      },
      setCookie: function setCookie(name, value, exdays) {
        var exdate = new Date(),
            c_value,
            secure = window.location.protocol === 'https:' ? true : false;
        exdate.setDate(exdate.getDate() + exdays);
        c_value = escape(value) + (exdays == null ? '' : '; expires=' + exdate.toUTCString());
        document.cookie = name + '=' + c_value + '; path=/' + '; secure';
      },
      // get/parse cookies
      getCookie: function getCookie(sName) {
        // reset boolean
        var g_bCookieFound = false;

        // split cookie into name/value pairs
        var aCookies = document.cookie.split(';'),
            aCookiesLength = aCookies.length,
            aCurrCookie = '',
            cookieName = '',
            cookieValue = '',
            i;

        for (i = 0; i < aCookiesLength; i++) {
          // each position now has a string of the form "name=value".
          // split name and value
          aCurrCookie = aCookies[i].split('=');

          // grab cookie name and value. Make sure there is no leading or trailing white space
          cookieName = aCurrCookie[0].replace(/^\s+|\s+$/g, '');

          // check if this is the cookie we are looking for
          if (cookieName === sName) {
            g_bCookieFound = true;

            // watch out for edge case: the cookie might not have an actual value
            if (aCurrCookie[1].length > 1) {
              cookieValue = unescape(aCurrCookie[1].replace(/^\s+|\s+$/g, ''));
            }

            return cookieValue;
          }

          // clean up vars for next iteration
          aCurrCookie = null;
          cookieName = '';
          cookieValue = '';
        }
        if (!g_bCookieFound) {
          return null;
        }
      },
      setCampaign: function setCampaign(campaignId) {
        var seenCmps = tnt_wdpro.getCookie('wdpro_seen_cmps'),
            found = false;

        campaignId = '/' + campaignId.toString() + '/';

        if (seenCmps && seenCmps.indexOf(campaignId) === -1) {
          seenCmps += ',' + campaignId;
        } else if (!seenCmps) {
          seenCmps = campaignId;
        }

        tnt_wdpro.setCookie(this.seenCmpCookie, seenCmps, 14);
      },
      getCampaigns: function getCampaigns() {
        return this.getCookie(this.seenCmpCookie);
      }
    };
    /* End WDPRO Additions */

    var TNT = TNT || {};

    TNT._internal = function () {
      return {
        nestedMboxes: [],

        _settings: {
          companyName: "Test&amp;Target",
          isProduction: true,
          adminUrl: "http://admin5.testandtarget.omniture.com/admin",
          clientCode: "disney",
          serverHost: "disney.tt.omtrdc.net",
          mboxTimeout: 10000,
          mboxLoadedTimeout: 100,
          mboxFactoryDisabledTimeout: 30 * 60,
          bodyPollingTimeout: 16,
          bodyHidingEnabled: false,
          bodyHiddenStyle: "body{opacity:0}",
          sessionExpirationTimeout: 31 * 60,
          experienceManagerDisabledTimeout: 30 * 60,
          experienceManagerTimeout: 5000,
          visitorApiTimeout: 500,
          visitorApiPageDisplayTimeout: 500,
          overrideMboxEdgeServer: true,
          overrideMboxEdgeServerTimeout: 31 * 60,
          tntIdLifetime: 7776000,
          crossDomain: "enabled",
          trafficDuration: 10368000,
          trafficLevelPercentage: 100,
          clientSessionIdSupport: false,
          clientTntIdSupport: false,
          passPageParameters: true,
          usePersistentCookies: true,
          crossDomainEnabled: true,
          crossDomainXOnly: false,
          imsOrgId: "EDA101AC512D2B230A490D4C@AdobeOrg",
          globalMboxName: "target-global-mbox",
          globalMboxLocationDomId: "",
          globalMboxAutoCreate: false,
          experienceManagerPluginUrl: "//cdn.tt.omtrdc.net/cdn/target.js",
          siteCatalystPluginName: "tt",
          mboxVersion: 62,
          optoutEnabled: false,
          secureOnly: false,
          mboxIsSupportedFunction: function mboxIsSupportedFunction() {
            return true;
          },
          parametersFunction: function parametersFunction() {
            return "host=" + window.location;
          },
          cookieDomainFunction: function cookieDomainFunction() {
            return mboxCookiePageDomain();
          }
        },

        _params: {
          _page: "mboxPage",
          _marketingCloudVisitorId: "mboxMCGVID",
          _audienceManagerLocationHint: "mboxMCGLH",
          _audienceManagerBlob: "mboxAAMB",
          _analyticsVisitorId: "mboxMCAVID",
          _supplementalDataId: "mboxMCSDID",
          _count: "mboxCount",
          _host: "mboxHost",
          _mboxFactoryId: "mboxFactoryId",
          _tntId: "mboxPC",
          _screenHeight: "screenHeight",
          _screenWidth: "screenWidth",
          _browserWidth: "browserWidth",
          _browserHeight: "browserHeight",
          _browserTimeOffset: "browserTimeOffset",
          _screenColorDepth: "colorDepth",
          _crossDomain: "mboxXDomain",
          _url: "mboxURL",
          _referrer: "mboxReferrer",
          _mboxVersion: "mboxVersion",
          _mboxName: "mbox",
          _mboxId: "mboxId",
          _domLoaded: "mboxDOMLoaded",
          _time: "mboxTime",
          _siteCatalystPluginVersion: "scPluginVersion"
        },

        _pageParams: {
          _disable: "mboxDisable",
          _sessionId: "mboxSession",
          _environment: "mboxEnv",
          _debug: "mboxDebug"
        },

        _cookies: {
          _disable: "disable",
          _sessionId: "session",
          _tntId: "PC",
          _trafficLevel: "level",
          _check: "check",
          _debug: "debug",
          _experienceManagerDisabled: "em-disabled",
          _mboxEdgeServer: "mboxEdgeServer"
        },

        _constants: {
          _defaultFactoryId: "default",
          _cookieNamePrefix: "mbox",
          _divImportPrefix: "mboxImported-",
          _millisInMinute: 60000,
          _divDefaultClass: "mboxDefault",
          _divMarkerPrefix: "mboxMarker-",
          _mboxNameMaxLength: 250,
          _siteCatalystPluginVersion: 1,
          _mboxEdgeServerPrefix: "mboxedge",
          _mboxClusterHostDomain: "tt.omtrdc.net"
        }
      };
    }();

    TNT._internal._helper = {};

    (function (_module) {
      var _str = {}.toString;

      function _isUndefined(_value) {
        return _value === void 0;
      }

      function _isNull(_value) {
        return _value === null;
      }

      function _isEmpty(_value) {
        if (_isUndefined(_value) || _isNull(_value)) {
          return true;
        }

        return _value.length === 0;
      }

      function _isFunction(_value) {
        return _str.call(_value) === '[object Function]';
      }

      function _isArray(_value) {
        return _str.call(_value) === '[object Array]';
      }

      function _isString(_value) {
        return _str.call(_value) === '[object String]';
      }

      function _isObject(_value) {
        return _str.call(_value) === '[object Object]';
      }

      function _forEach(_arr, _fn) {
        var _len = _arr.length,
            _idx = -1;

        while (++_idx < _len) {
          _fn(_arr[_idx]);
        }
      }

      _module._isUndefined = _isUndefined;
      _module._isNull = _isNull;
      _module._isEmpty = _isEmpty;
      _module._isFunction = _isFunction;
      _module._isArray = _isArray;
      _module._isString = _isString;
      _module._isObject = _isObject;
      _module._forEach = _forEach;
    })(TNT._internal._helper);

    mboxUrlBuilder = function mboxUrlBuilder(_mboxServer, _clientCode) {
      this._mboxServer = _mboxServer;
      this._clientCode = _clientCode;
      this._parameters = [];
      this._urlProcess = function (_url) {
        return _url;
      };
      this._basePath = null;
    };

    mboxUrlBuilder.prototype = {
      constructor: mboxUrlBuilder,

      addNewParameter: function addNewParameter(_name, _value) {
        this._parameters.push({ name: _name, value: _value });

        return this;
      },

      addParameterIfAbsent: function addParameterIfAbsent(_name, _value) {
        if (!_value) {
          return;
        }

        for (var _i = 0; _i < this._parameters.length; _i++) {
          var _parameter = this._parameters[_i];

          if (_parameter.name === _name) {
            return this;
          }
        }

        this.checkInvalidCharacters(_name);

        return this.addNewParameter(_name, _value);
      },

      addParameter: function addParameter(_name, _value) {
        this.checkInvalidCharacters(_name);

        for (var _i = 0; _i < this._parameters.length; _i++) {
          var _parameter = this._parameters[_i];

          if (_parameter.name === _name) {
            _parameter.value = _value;

            return this;
          }
        }

        return this.addNewParameter(_name, _value);
      },

      addParameters: function addParameters(_parameters) {
        if (!_parameters) {
          return this;
        }

        for (var _i = 0; _i < _parameters.length; _i++) {
          var _pair = _parameters[_i];
          var _splitIndex = _pair.indexOf('=');

          if (_splitIndex === -1 || _splitIndex === 0) {
            continue;
          }

          this.addParameter(_pair.substring(0, _splitIndex), _pair.substring(_splitIndex + 1, _pair.length));
        }

        return this;
      },

      setServerType: function setServerType(_type) {
        this._serverType = _type;
      },

      setBasePath: function setBasePath(_basePath) {
        this._basePath = _basePath;
      },

      setUrlProcessAction: function setUrlProcessAction(_action) {
        this._urlProcess = _action;
      },

      buildUrl: function buildUrl() {
        var _secureOnly = TNT._internal._settings.secureOnly,
            _protocol = _secureOnly ? 'https:' : '',
            _server = TNT._internal._getMboxEdgeServer(this._mboxServer),
            _path = this._basePath ? this._basePath : '/m2/' + this._clientCode + '/mbox/' + this._serverType,
            _url = _protocol + '//' + _server + _path,
            _parts = [];

        for (var _i = 0; _i < this._parameters.length; _i++) {
          var _parameter = this._parameters[_i];

          _parts.push(encodeURIComponent(_parameter.name) + '=' + encodeURIComponent(_parameter.value));
        }

        _url += _url.indexOf('?') != -1 ? '&' + _parts.join('&') : '?' + _parts.join('&');

        return this._escapeQuote(this._urlProcess(_url));
      },

      getParameters: function getParameters() {
        return this._parameters;
      },

      setParameters: function setParameters(_parameters) {
        this._parameters = _parameters;
      },

      clone: function clone() {
        var _newUrlBuilder = new mboxUrlBuilder(this._mboxServer, this._clientCode);

        _newUrlBuilder.setServerType(this._serverType);
        _newUrlBuilder.setBasePath(this._basePath);
        _newUrlBuilder.setUrlProcessAction(this._urlProcess);

        for (var _i = 0; _i < this._parameters.length; _i++) {
          _newUrlBuilder.addParameter(this._parameters[_i].name, this._parameters[_i].value);
        }

        return _newUrlBuilder;
      },

      _escapeQuote: function _escapeQuote(_text) {
        return _text.replace(/\"/g, '&quot;').replace(/>/g, '&gt;');
      },

      checkInvalidCharacters: function checkInvalidCharacters(_name) {
        var _invalidCharacters = new RegExp('(\'|")');

        if (_invalidCharacters.exec(_name)) {
          throw "Parameter '" + _name + "' contains invalid characters";
        }
      }
    };

    // This module represents a callback counter or
    // more familiar to Java people a cyclic barrier

    TNT._internal._join = function () {
      var _waiting = [],
          _done = 0,
          _callbacks = [];

      function _partial(_index, _args) {
        _done += 1;
        _waiting[_index] = _args;

        _complete();
      }

      function _complete() {
        var _len = _callbacks.length,
            _idx = -1,
            _cb;

        if (_done !== _waiting.length || !_callbacks.length) {
          return;
        }

        while (++_idx < _len) {
          _cb = _callbacks[_idx];
          _cb.fn.apply(_cb.ctx, _waiting);
        }
      }

      return {
        _add: function _add() {
          var _index = _waiting.length;

          _waiting[_waiting.length] = null;

          return function () {
            _partial(_index, [].slice.call(arguments));
          };
        },

        _then: function _then(cb, context) {
          _callbacks.push({ fn: cb, ctx: context });
          _complete();
        }
      };
    };

    (function (_module, _helper, _params, _settings, _joinFactory) {
      var _MC_ID_COOKIE_REGEXP = new RegExp("\\|MCMID\\|"),
          _VISITOR_PARAM_PREFIX = 'vst.',
          _TRACKING_SERVER_PARAM = _VISITOR_PARAM_PREFIX + 'trk',
          _TRACKING_SERVER_SECURE_PARAM = _VISITOR_PARAM_PREFIX + 'trks';

      function _createParam(_key, _value) {
        return encodeURIComponent(_key) + '=' + encodeURIComponent(_value);
      }

      function _getCustomerIdsParameters(_visitor) {
        var _customerIds,
            _keyFunc = function _keyFunc(_key) {
          return _VISITOR_PARAM_PREFIX + _key;
        };

        if (!_helper._isFunction(_visitor.getCustomerIDs)) {
          return [];
        }

        _customerIds = _visitor.getCustomerIDs();

        if (!_helper._isObject(_customerIds)) {
          return [];
        }

        return _module._extractParamsFromObject(_customerIds, [], _keyFunc);
      }

      function _addTrackingServers(_visitor, _result) {
        var _trackingServer = _visitor.trackingServer,
            _trackingServerSecure = _visitor.trackingServerSecure;

        if (_trackingServer) {
          _result.push(_createParam(_TRACKING_SERVER_PARAM, _trackingServer));
        }

        if (_trackingServerSecure) {
          _result.push(_createParam(_TRACKING_SERVER_SECURE_PARAM, _trackingServerSecure));
        }
      }

      function _addCustomerIdParameters(_visitor, _result) {
        _result.push.apply(_result, _getCustomerIdsParameters(_visitor));
      }

      function _collectVisitorApiParameters(_args) {
        var _result = [];

        _helper._forEach(_args, function (_arr) {
          _result.push(_arr[0]);
        });

        return _result;
      }

      function _hasValue(_item) {
        return !_helper._isEmpty(_item.value);
      }

      function _fireVisitorApiRequest(_join, _visitor, _method, _key) {
        var _notify;

        if (!_helper._isFunction(_visitor[_method])) {
          return;
        }

        _notify = _join._add();

        // We are forcing callback execution for each Visitor API method,
        // this is to ensure an uniform execution, both when data is retrieved from remote server
        // as well as when it is read from cookie
        _visitor[_method](function (_value) {
          _notify({ key: _key, value: _value });
        }, true);
      }

      function _executeForEachVisitorApiMethod(_join, _visitor, _func) {
        _func(_join, _visitor, 'getMarketingCloudVisitorID', _params._marketingCloudVisitorId);
        _func(_join, _visitor, 'getAudienceManagerBlob', _params._audienceManagerBlob);
        _func(_join, _visitor, 'getAnalyticsVisitorID', _params._analyticsVisitorId);
        _func(_join, _visitor, 'getAudienceManagerLocationHint', _params._audienceManagerLocationHint);
      }

      function _fireVisitorApiRequests(_join, _visitor, _timerContext, _optout, _callback) {
        if (_optout) {
          window.clearTimeout(_timerContext.id);

          _callback({ optout: _optout, params: [] });

          _showBodyIfRequired();

          return;
        }

        _executeForEachVisitorApiMethod(_join, _visitor, _fireVisitorApiRequest);

        _join._then(function () {
          if (_timerContext.done) {
            return;
          }

          var _params = _collectVisitorApiParameters([].slice.call(arguments)),
              _result = [];

          window.clearTimeout(_timerContext.id);

          _helper._forEach(_params, function (_item) {
            if (_hasValue(_item)) {
              _result.push(_createParam(_item.key, _item.value));
            }
          });

          _addCustomerIdParameters(_visitor, _result);
          _addTrackingServers(_visitor, _result);

          _callback({ optout: _optout, params: _result });

          _showBodyIfRequired();
        });
      }

      function _getVisitorApiClientIfExists(_imsOrgId) {
        var _visitor;

        if (_helper._isEmpty(_imsOrgId) || _helper._isUndefined(window.Visitor) || !_helper._isFunction(window.Visitor.getInstance)) {
          return null;
        }

        _visitor = window.Visitor.getInstance(_imsOrgId);

        if (_helper._isUndefined(_visitor) || _helper._isNull(_visitor) || !_visitor.isAllowed()) {
          return null;
        }

        return _visitor;
      }

      // Exported functions

      function _isVisitorApiAvailable() {
        return !_helper._isNull(_getVisitorApiClientIfExists(_settings.imsOrgId));
      }

      function _isMarketingCloudDataAvailable() {
        var _visitor = _getVisitorApiClientIfExists(_settings.imsOrgId);

        if (_helper._isNull(_visitor)) {
          return false;
        }

        if (_helper._isUndefined(_visitor.cookieName)) {
          return false;
        }

        if (!_helper._isFunction(_visitor.cookieRead)) {
          return false;
        }

        var _visitorCookie = _visitor.cookieRead(_visitor.cookieName);

        if (_helper._isEmpty(_visitorCookie)) {
          return false;
        }

        return _MC_ID_COOKIE_REGEXP.test(_visitorCookie);
      }

      function _shouldUseOptout(_visitor, _optoutEnabled) {
        return _optoutEnabled && _helper._isFunction(_visitor.isOptedOut) && !_helper._isUndefined(window.Visitor.OptOut);
      }

      function _getMarketingCloudDataAsync(_optoutEnabled, _callback) {
        var _imsOrgId = _settings.imsOrgId,
            _visitorApiTimeout = _settings.visitorApiTimeout,
            _join = _joinFactory(),
            _timerContext = { id: NaN, done: false },
            _visitor;

        _visitor = _getVisitorApiClientIfExists(_imsOrgId);

        if (_helper._isNull(_visitor)) {
          _callback(null);

          return;
        }

        _hideBodyIfRequired();

        _timerContext.id = window.setTimeout(function () {
          _timerContext.done = true;

          _callback(null);

          _showBodyIfRequired();
        }, _visitorApiTimeout);

        if (_shouldUseOptout(_visitor, _optoutEnabled)) {
          _visitor.isOptedOut(function (_optout) {
            _fireVisitorApiRequests(_join, _visitor, _timerContext, _optout, _callback);
          }, window.Visitor.OptOut.GLOBAL, true);
        } else {
          _fireVisitorApiRequests(_join, _visitor, _timerContext, false, _callback);
        }
      }

      function _addParam(_visitor, _method, _key, _accumulator) {
        if (_visitor[_method]) {
          var _value = _visitor[_method]();

          if (_value) {
            _accumulator.push(_createParam(_key, _value));
          }
        }
      }

      function _getMarketingCloudData() {
        var _visitor = _getVisitorApiClientIfExists(_settings.imsOrgId),
            _result = [];

        _addParam(_visitor, 'getMarketingCloudVisitorID', _params._marketingCloudVisitorId, _result);
        _addParam(_visitor, 'getAudienceManagerBlob', _params._audienceManagerBlob, _result);
        _addParam(_visitor, 'getAnalyticsVisitorID', _params._analyticsVisitorId, _result);
        _addParam(_visitor, 'getAudienceManagerLocationHint', _params._audienceManagerLocationHint, _result);

        _addCustomerIdParameters(_visitor, _result);
        _addTrackingServers(_visitor, _result);

        return _result;
      }

      function _generateSupplementalDataId(_mboxName) {
        var _imsOrgId = _settings.imsOrgId,
            _clientCode = _settings.clientCode,
            _visitor = _getVisitorApiClientIfExists(_imsOrgId);

        if (_helper._isNull(_visitor) || !_helper._isFunction(_visitor.getSupplementalDataID)) {
          return '';
        }

        return _visitor.getSupplementalDataID('mbox:' + _clientCode + ':' + _mboxName);
      }

      function _hideBodyIfRequired() {
        if (!_settings.bodyHidingEnabled) {
          return;
        }

        if (!_settings.globalMboxAutoCreate) {
          return;
        }

        var _head = document.getElementsByTagName('head')[0];
        var _style = document.createElement('style');
        _style.type = 'text/css';
        _style.id = 'at-id-body-style';

        if (_style.styleSheet) {
          _style.styleSheet.cssText = css;
        } else {
          _style.appendChild(document.createTextNode(_settings.bodyHiddenStyle));
        }

        if (_head) {
          _head.appendChild(_style);
        }
      }

      function _showBodyIfRequired() {
        if (!_settings.bodyHidingEnabled) {
          return;
        }

        if (!_settings.globalMboxAutoCreate) {
          return;
        }

        window.setTimeout(function () {
          var _head = document.getElementsByTagName('head')[0];
          var _style = document.getElementById('at-id-body-style');

          if (_head && _style) {
            _head.removeChild(_style);
          }
        }, _settings.visitorApiPageDisplayTimeout);
      }

      _module._isVisitorApiAvailable = _isVisitorApiAvailable;
      _module._isMarketingCloudDataAvailable = _isMarketingCloudDataAvailable;
      _module._getMarketingCloudDataAsync = _getMarketingCloudDataAsync;
      _module._getMarketingCloudData = _getMarketingCloudData;
      _module._generateSupplementalDataId = _generateSupplementalDataId;
    })(TNT._internal, TNT._internal._helper, TNT._internal._params, TNT._internal._settings, TNT._internal._join);

    mboxStandardFetcher = function mboxStandardFetcher() {};

    mboxStandardFetcher.prototype = {
      constructor: mboxStandardFetcher,

      getType: function getType() {
        return 'standard';
      },

      fetch: function fetch(_urlBuilder) {
        _urlBuilder.setServerType(this.getType());

        document.write('<' + 'scr' + 'ipt src="' + _urlBuilder.buildUrl() + '"><' + '\/scr' + 'ipt>');
      },

      cancel: function cancel() {}
    };

    mboxAjaxFetcher = function mboxAjaxFetcher() {};

    mboxAjaxFetcher.prototype = {
      constructor: mboxAjaxFetcher,

      getType: function getType() {
        return 'ajax';
      },

      fetch: function fetch(_urlBuilder) {
        _urlBuilder.setServerType(this.getType());

        var _head = document.getElementsByTagName('head')[0],
            _include = document.createElement('script');

        _include.src = _urlBuilder.buildUrl();

        _head.appendChild(_include);
      },

      cancel: function cancel() {}
    };

    (function (_module) {
      function _globalMboxFetcher() {}

      _globalMboxFetcher.prototype = {
        constructor: _globalMboxFetcher,

        getType: function getType() {
          return 'ajax';
        },

        fetch: function fetch(_urlBuilder) {
          _urlBuilder.setServerType(this.getType());

          document.write('<' + 'scr' + 'ipt src="' + _urlBuilder.buildUrl() + '"><' + '\/scr' + 'ipt>');
        },

        cancel: function cancel() {}
      };

      _module._globalMboxFetcher = _globalMboxFetcher;
    })(TNT._internal);

    mboxMap = function mboxMap() {
      this._backingMap = {};
      this._keys = [];
    };

    mboxMap.prototype = {
      constructor: mboxMap,

      put: function put(_key, _value) {
        if (!this._backingMap[_key]) {
          this._keys[this._keys.length] = _key;
        }

        this._backingMap[_key] = _value;
      },

      get: function get(_key) {
        return this._backingMap[_key];
      },

      remove: function remove(_key) {
        var _updatedKeys = [];
        this._backingMap[_key] = undefined;

        for (var i = 0; i < this._keys.length; i++) {
          if (this._keys[i] !== _key) {
            _updatedKeys.push(this._keys[i]);
          }
        }

        this._keys = _updatedKeys;
      },

      each: function each(_action) {
        for (var _i = 0; _i < this._keys.length; _i++) {
          var _key = this._keys[_i];
          var _value = this._backingMap[_key];

          if (_value) {
            var _result = _action(_key, _value);

            if (_result === false) {
              break;
            }
          }
        }
      },

      isEmpty: function isEmpty() {
        return this._keys.length === 0;
      }
    };

    mboxList = function mboxList() {
      this._mboxes = [];
    };

    mboxList.prototype = {
      constructor: mboxList,

      add: function add(_mbox) {
        if (!_mbox) {
          return;
        }

        this._mboxes.push(_mbox);
      },

      get: function get(_mboxName) {
        var _result = new mboxList();

        for (var _i = 0; _i < this._mboxes.length; _i++) {
          var _mbox = this._mboxes[_i];

          if (_mbox.getName() === _mboxName) {
            _result.add(_mbox);
          }
        }

        return _result;
      },

      getById: function getById(_index) {
        return this._mboxes[_index];
      },

      length: function length() {
        return this._mboxes.length;
      },

      each: function each(_action) {
        var _helper = TNT._internal._helper;

        if (!_helper._isFunction(_action)) {
          throw 'Action must be a function, was: ' + typeof _action;
        }

        for (var _i = 0; _i < this._mboxes.length; _i++) {
          _action(this._mboxes[_i]);
        }
      }
    };

    mboxSignaler = function mboxSignaler(_factory) {
      this._factory = _factory;
    };

    mboxSignaler.prototype = {
      constructor: mboxSignaler,

      signal: function signal(_signalType, _mboxName /*,...*/) {
        if (!this._factory.isEnabled()) {
          return;
        }

        var _body = mboxSignaler._getDocumentBody(),
            _divNode = this._createDivNode(this._factory._getMboxMarkerDivId(_mboxName));

        _body.appendChild(_divNode);

        var _args = [].slice.call(arguments, 1),
            _mbox = this._factory.create(_mboxName, _args, _divNode),
            _urlBuilder = _mbox.getUrlBuilder();

        _urlBuilder.addParameter(TNT._internal._params._page, mboxGenerateId());
        _mbox.setFetcher(new mboxAjaxFetcher());
        _mbox.load();
      },

      _createDivNode: function _createDivNode(_id) {
        var _result = document.createElement('div');

        _result.id = _id;
        _result.style.visibility = 'hidden';
        _result.style.display = 'none';

        return _result;
      }
    };

    mboxSignaler._getDocumentBody = function () {
      return document.body;
    };

    //
    // Note this constructor also writes a node to the DOM, do not create
    // after the page is loaded
    //
    mboxLocatorDefault = function mboxLocatorDefault(_divId) {
      this._divId = _divId;

      document.write('<div id="' + this._divId + '" style="visibility:hidden;display:none">&nbsp;<\/div>');
    };

    mboxLocatorDefault.prototype = {
      constructor: mboxLocatorDefault,

      locate: function locate() {
        var _ELEMENT_NODE = 1,
            _node = document.getElementById(this._divId);

        while (_node) {
          if (_node.nodeType === _ELEMENT_NODE && _node.className && _node.className.indexOf('mboxDefault') !== -1) {
            return _node;
          }

          _node = _node.previousSibling;
        }

        return null;
      },

      force: function force() {
        // There was no default div, add an empty one
        var _marker = document.getElementById(this._divId),
            _div = document.createElement('div');

        _div.className = 'mboxDefault';

        if (_marker) {
          _marker.parentNode.insertBefore(_div, _marker);
        }

        return _div;
      }
    };

    mboxLocatorNode = function mboxLocatorNode(_node) {
      this._node = _node;
    };

    mboxLocatorNode.prototype = {
      constructor: mboxLocatorNode,

      locate: function locate() {
        return typeof this._node === 'string' ? document.getElementById(this._node) : this._node;
      },

      force: function force() {
        return null;
      }
    };

    mboxOfferContent = function mboxOfferContent() {
      this._onLoad = function () {};
    };

    mboxOfferContent.prototype = {
      constructor: mboxOfferContent,

      show: function show(_mbox) {
        var _result = _mbox.showContent(document.getElementById(_mbox.getImportName()));

        if (_result === 1) {
          this._onLoad();
        }

        return _result;
      },

      setOnLoad: function setOnLoad(_onLoad) {
        this._onLoad = _onLoad;
      }
    };

    mboxOfferAjax = function mboxOfferAjax(_content) {
      this._content = _content;
      this._onLoad = function () {};
    };

    mboxOfferAjax.prototype = {
      constructor: mboxOfferAjax,

      setOnLoad: function setOnLoad(_onLoad) {
        this._onLoad = _onLoad;
      },

      show: function show(_mbox) {
        var _contentDiv = document.createElement('div'),
            _result;

        _contentDiv.id = _mbox.getImportName();
        _contentDiv.innerHTML = this._content;

        _result = _mbox.showContent(_contentDiv);

        if (_result === 1) {
          this._onLoad();
        }

        return _result;
      }
    };

    mboxOfferDefault = function mboxOfferDefault() {
      this._onLoad = function () {};
    };

    mboxOfferDefault.prototype = {
      constructor: mboxOfferDefault,

      show: function show(_mbox) {
        var _result = _mbox.hide();

        if (_result === 1) {
          this._onLoad();
        }

        return _result;
      },

      setOnLoad: function setOnLoad(_onLoad) {
        this._onLoad = _onLoad;
      }
    };

    mboxCookieManager = function mboxCookieManager(_name, _domain) {
      this._name = _name;
      this._checkCookie = TNT._internal._cookies._check;
      this._crossDomainXOnly = TNT._internal._settings.crossDomainXOnly;
      this._disableCookie = TNT._internal._cookies._disable;
      this._usePersistentCookies = TNT._internal._settings.usePersistentCookies;
      this._cookiesMap = new mboxMap();

      // single word domains are not accepted in a cookie domain clause
      this._domain = _domain === '' || _domain.indexOf('.') === -1 ? '' : '; domain=' + _domain;

      this.loadCookies();
    };

    mboxCookieManager.prototype = {
      constructor: mboxCookieManager,

      isEnabled: function isEnabled() {
        this.setCookie(this._checkCookie, 'true', 60);
        this.loadCookies();

        return this.getCookie(this._checkCookie) == 'true';
      },

      setCookie: function setCookie(_name, _value, _duration) {
        if (typeof _name == 'undefined' || typeof _value == 'undefined' || typeof _duration == 'undefined') {
          return;
        }

        var _expireOn = Math.ceil(_duration + new Date().getTime() / 1000),
            _cookie = mboxCookieManager._createCookie(_name, encodeURIComponent(_value), _expireOn);

        this._cookiesMap.put(_name, _cookie);
        this.saveCookies();
      },

      getCookie: function getCookie(_name) {
        var _cookie = this._cookiesMap.get(_name);

        return _cookie ? decodeURIComponent(_cookie.value) : null;
      },

      deleteCookie: function deleteCookie(_name) {
        this._cookiesMap.remove(_name);
        this.saveCookies();
      },

      getCookieNames: function getCookieNames(_namePrefix) {
        var _cookieNames = [];

        this._cookiesMap.each(function (_name, _cookie) {
          if (_name.indexOf(_namePrefix) === 0) {
            _cookieNames[_cookieNames.length] = _name;
          }
        });

        return _cookieNames;
      },

      saveCookies: function saveCookies() {
        var _self = this,
            _cookieValues = [],
            _maxExpireOn = 0;

        this._cookiesMap.each(function (_name, _cookie) {
          if (!_self._crossDomainXOnly || _name === _self._disableCookie) {
            _cookieValues[_cookieValues.length] = mboxCookieManager._serializeCookie(_cookie);

            if (_maxExpireOn < _cookie.expireOn) {
              _maxExpireOn = _cookie.expireOn;
            }
          }
        });

        var _expiration = new Date(_maxExpireOn * 1000);
        var _parts = [];

        _parts.push(this._name, '=', _cookieValues.join('|'));

        if (_self._usePersistentCookies) {
          _parts.push('; expires=', _expiration.toGMTString());
        }

        _parts.push('; path=/', this._domain);

        document.cookie = _parts.join("");
      },

      loadCookies: function loadCookies() {
        var _masterCookie = mboxCookieManager._getMasterCookie(this._name),
            _internalCookies = mboxCookieManager._getInternalCookies(_masterCookie),
            _nowInSeconds = Math.ceil(new Date().getTime() / 1000);

        this._cookiesMap = new mboxMap();

        for (var _i = 0; _i < _internalCookies.length; _i++) {
          var _cookie = mboxCookieManager._deserializeCookie(_internalCookies[_i]);

          if (_nowInSeconds > _cookie.expireOn) {
            continue;
          }

          this._cookiesMap.put(_cookie.name, _cookie);
        }
      }
    };

    mboxCookieManager._serializeCookie = function (_cookie) {
      return _cookie.name + '#' + _cookie.value + '#' + _cookie.expireOn;
    };

    mboxCookieManager._deserializeCookie = function (_str) {
      var _parts = _str.split('#');

      return mboxCookieManager._createCookie(_parts[0], _parts[1], _parts[2]);
    };

    mboxCookieManager._createCookie = function (_name, _value, _expireOn) {
      return { name: _name, value: _value, expireOn: _expireOn };
    };

    mboxCookieManager._getMasterCookie = function (_name) {
      var result = new RegExp('(^|; )' + encodeURIComponent(_name) + '=([^;]*)').exec(document.cookie);

      return result ? result[2] : null;
    };

    mboxCookieManager._getInternalCookies = function (_str) {
      if (!_str) {
        return [];
      }

      return _str.split('|');
    };

    mboxSession = function mboxSession(_randomId, _pageParamName, _cookieName, _expireTime, _cookieManager) {
      var _forcedSessionId = window.mboxForceSessionId;
      this._cookieName = _cookieName;
      this._expireTime = _expireTime;
      this._cookieManager = _cookieManager;
      this._id = typeof _forcedSessionId !== 'undefined' ? _forcedSessionId : mboxGetPageParameter(_pageParamName, true);
      this._id = this._id || _cookieManager.getCookie(_cookieName) || _randomId;

      this._cookieManager.setCookie(_cookieName, this._id, _expireTime);
    };

    mboxSession.prototype = {
      constructor: mboxSession,

      getId: function getId() {
        return this._id;
      },

      forceId: function forceId(_forcedId) {
        this._id = _forcedId;

        this._cookieManager.setCookie(this._cookieName, this._id, this._expireTime);
      }
    };

    mboxPC = function mboxPC(_cookieName, _expireTime, _cookieManager) {
      var _forcedPCId = window.mboxForcePCId;
      this._cookieName = _cookieName;
      this._expireTime = _expireTime;
      this._cookieManager = _cookieManager;
      this._id = typeof _forcedPCId != 'undefined' ? _forcedPCId : _cookieManager.getCookie(_cookieName);

      if (this._id) {
        _cookieManager.setCookie(_cookieName, this._id, _expireTime);
      }
    };

    mboxPC.prototype = {
      constructor: mboxPC,

      getId: function getId() {
        return this._id;
      },

      forceId: function forceId(_forcedId) {
        if (this._id === _forcedId) {
          return false;
        }

        this._id = _forcedId;
        this._cookieManager.setCookie(this._cookieName, this._id, this._expireTime);

        return true;
      }
    };

    (function (_module, _helper, _cookies, _settings, _constants) {
      var _mboxEdgeExtractorRegex = new RegExp(".*\\.(\\d+)_\\d+");

      function _getMboxEdgeServer(_pcIdValue) {
        var _match = _mboxEdgeExtractorRegex.exec(_pcIdValue);

        if (_match && _match.length === 2) {
          return _constants._mboxEdgeServerPrefix + _match[1] + '.' + _constants._mboxClusterHostDomain;
        }

        return '';
      }

      function _saveMboxEdgeServerToCookieIfExists(_cookieManager, _pcId) {
        var _server = _getMboxEdgeServer(_pcId);

        if (!_helper._isEmpty(_server)) {
          _cookieManager.setCookie(_cookies._mboxEdgeServer, _server, _settings.overrideMboxEdgeServerTimeout);
        }
      }

      function _pcDecorator(_pc, _cookieManager) {
        this._pc = _pc;
        this._cookieManager = _cookieManager;

        _saveMboxEdgeServerToCookieIfExists(_cookieManager, _pc.getId());
      }

      _pcDecorator.prototype = {
        constructor: _pcDecorator,

        getId: function getId() {
          return this._pc.getId();
        },

        forceId: function forceId(_forcedId) {
          if (!this._pc.forceId(_forcedId)) {
            return false;
          }

          _saveMboxEdgeServerToCookieIfExists(this._cookieManager, _forcedId);

          return true;
        }
      };

      _module._pcDecorator = _pcDecorator;
    })(TNT._internal, TNT._internal._helper, TNT._internal._cookies, TNT._internal._settings, TNT._internal._constants);
    mboxGetPageParameter = function mboxGetPageParameter(_name, _ignoreCase) {
      _ignoreCase = _ignoreCase || false;

      var _parameterRegExp;

      if (_ignoreCase) {
        _parameterRegExp = new RegExp("\\?[^#]*" + _name + "=([^\&;#]*)", "i");
      } else {
        _parameterRegExp = new RegExp("\\?[^#]*" + _name + "=([^\&;#]*)");
      }

      var _result = null;
      var _parameterMatch = _parameterRegExp.exec(document.location);

      if (_parameterMatch && _parameterMatch.length >= 2) {
        _result = _parameterMatch[1];
      }

      return _result;
    };

    mboxCookiePageDomain = function mboxCookiePageDomain() {
      var _domain = /([^:]*)(:[0-9]{0,5})?/.exec(document.location.host)[1];
      var _ipRegExp = /[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}/;

      if (!_ipRegExp.exec(_domain)) {
        var _baseDomain = /([^\.]+\.[^\.]{3}|[^\.]+\.[^\.]+\.[^\.]{2})$/.exec(_domain);

        if (_baseDomain) {
          _domain = _baseDomain[0];

          if (_domain.indexOf("www.") === 0) {
            _domain = _domain.substr(4);
          }
        }
      }

      return _domain ? _domain : "";
    };

    mboxShiftArray = function mboxShiftArray(_iterable) {
      var _result = [];

      for (var _i = 1; _i < _iterable.length; _i++) {
        _result[_result.length] = _iterable[_i];
      }

      return _result;
    };

    mboxGenerateId = function mboxGenerateId() {
      // http://www.ietf.org/rfc/rfc4122.txt
      var s = [],
          hex = '0123456789abcdef';

      for (var i = 0; i < 36; i++) {
        s[i] = hex.substr(Math.floor(Math.random() * 0x10), 1);
      }
      // bits 12-15 of the time_hi_and_version field to 0010
      s[14] = '4';
      // bits 6-7 of the clock_seq_hi_and_reserved to 01
      s[19] = hex.substr(s[19] & 0x3 | 0x8, 1);
      s[8] = s[13] = s[18] = s[23] = '-';

      return s.join('').replace(/-/g, '');
    };

    mboxScreenHeight = function mboxScreenHeight() {
      return screen.height;
    };

    mboxScreenWidth = function mboxScreenWidth() {
      return screen.width;
    };

    mboxBrowserWidth = function mboxBrowserWidth() {
      return window.innerWidth ? window.innerWidth : document.documentElement ? document.documentElement.clientWidth : document.body.clientWidth;
    };

    mboxBrowserHeight = function mboxBrowserHeight() {
      return window.innerHeight ? window.innerHeight : document.documentElement ? document.documentElement.clientHeight : document.body.clientHeight;
    };

    mboxBrowserTimeOffset = function mboxBrowserTimeOffset() {
      return -new Date().getTimezoneOffset();
    };

    mboxScreenColorDepth = function mboxScreenColorDepth() {
      return screen.pixelDepth;
    };

    /**
     * Class that is the base of all mbox types.
     * @PrivateClass
     *
     * @param _name - name of mbox
     * @param _id - index of this mbox in the list of mboxes of the same name
     * @param _urlBuilder - used to build url of the request
     * @param _mboxLocator object must support
     *   DOMNode locate() which should return null until the DOMNode is found.
     *   DOMNode force() which as a last resort should attempt to create
     *                   a DOMNOde and return it or null
     * @param _importName id of the node containing offer content
     * @param _factory factory that tries to create this mbox
     */
    mbox = function mbox(_name, _id, _urlBuilder, _mboxLocator, _importName, _factory) {
      this._timeout = null;
      this._activated = 0;
      this._locator = _mboxLocator;
      this._importName = _importName;
      this._contentFetcher = null;

      this._offer = new mboxOfferContent();
      this._div = null;
      this._urlBuilder = _urlBuilder;

      // Information to support debugging
      this.message = '';
      this._times = {};
      this._activateCount = 0;
      this._maxActivateCount = 5;

      this._id = _id;
      this._name = _name;

      this._validateName();

      _urlBuilder.addParameter(TNT._internal._params._mboxName, _name);
      _urlBuilder.addParameter(TNT._internal._params._mboxId, _id);

      this._onError = function () {};
      this._onLoad = function () {};

      this._defaultDiv = null;
      // enabled for IE10+ only during page load
      this._waitForNestedMboxes = document.documentMode >= 10 && !_factory.isDomLoaded();

      if (this._waitForNestedMboxes) {
        this._nestedMboxes = TNT._internal.nestedMboxes;
        this._nestedMboxes.push(this._name);
      }
    };

    mbox.prototype.getId = function () {
      return this._id;
    };

    mbox.prototype._validateName = function () {
      var maxLength = TNT._internal._constants._mboxNameMaxLength;

      if (this._name.length > maxLength) {
        throw "Mbox Name " + this._name + " exceeds max length of " + maxLength + " characters.";
      } else if (this._name.match(/^\s+|\s+$/g)) {
        throw "Mbox Name " + this._name + " has leading/trailing whitespace(s).";
      }
    };

    mbox.prototype.getName = function () {
      return this._name;
    };

    /**
     * @return Array an array of parameters
     */
    mbox.prototype.getParameters = function () {
      var _parameters = this._urlBuilder.getParameters();
      var _result = [];

      for (var _i = 0; _i < _parameters.length; _i++) {
        // do not include internal parameters
        if (_parameters[_i].name.indexOf('mbox') !== 0) {
          _result[_result.length] = _parameters[_i].name + '=' + _parameters[_i].value;
        }
      }

      return _result;
    };

    /**
     * Sets the action to execute when the offer has loaded.
     * To be used with mboxUpdate.
     */
    mbox.prototype.setOnLoad = function (_action) {
      this._onLoad = _action;
      return this;
    };

    mbox.prototype.setMessage = function (_message) {
      this.message = _message;
      return this;
    };

    /**
     * @param _onError is a function that takes two string arguments:
     *   message, fetch type
     */
    mbox.prototype.setOnError = function (_onError) {
      this._onError = _onError;
      return this;
    };

    mbox.prototype.setFetcher = function (_fetcher) {
      if (this._contentFetcher) {
        this._contentFetcher.cancel();
      }
      this._contentFetcher = _fetcher;
      return this;
    };

    mbox.prototype.getFetcher = function () {
      return this._contentFetcher;
    };

    function _fireRequest(_urlBuilder, _mbox) {
      var _context = TNT._internal,
          _settings = _context._settings,
          _mboxTimeout = _settings.mboxTimeout;

      if (_context._isVisitorApiAvailable() && _context._isMarketingCloudDataAvailable()) {
        _urlBuilder.addParameters(_context._getMarketingCloudData());
      }

      _mbox._contentFetcher.fetch(_urlBuilder);

      _mbox._timer = setTimeout(function () {
        _mbox._onError('browser timeout', _mbox._contentFetcher.getType());
      }, _mboxTimeout);
    }

    function _showMbox(_mbox) {
      var _defaultDiv = _mbox.getDefaultDiv();

      if (_defaultDiv) {
        _mbox._showDiv(_mbox.getDefaultDiv());
      }
    }

    function _fireRequestAsync(_urlBuilder, _mbox, _optoutEnabled) {
      var _context = TNT._internal;

      _mbox.setFetcher(new mboxAjaxFetcher());

      _context._getMarketingCloudDataAsync(_optoutEnabled, function (_data) {
        if (_data === null) {
          _fireRequest(_urlBuilder, _mbox);
          return;
        }

        if (_optoutEnabled && _data.optout) {
          _showMbox(_mbox);
          return;
        }

        _urlBuilder.addParameters(_data.params);
        _fireRequest(_urlBuilder, _mbox);
      });
    }

    /**
     * Loads mbox content.
     * @param _parameters - Optional parameters to be added to the request.
     */
    mbox.prototype.load = function (_parameters) {
      var _self = this,
          _urlBuilder = _self._urlBuilder,
          _context = TNT._internal,
          _settings = _context._settings,
          _optoutEnabled = _settings.optoutEnabled;

      if (_self._contentFetcher === null) {
        return _self;
      }

      _self.cancelTimeout();
      _self._activated = 0;

      if (_parameters && _parameters.length > 0) {
        _urlBuilder = _self._urlBuilder.clone().addParameters(_parameters);
      }

      if (_optoutEnabled && _context._isVisitorApiAvailable()) {
        _fireRequestAsync(_urlBuilder, _self, _optoutEnabled);
        return _self;
      }

      var _isVisitorApiAvailable = _context._isVisitorApiAvailable();

      if (_isVisitorApiAvailable && !_context._isMarketingCloudDataAvailable()) {
        _fireRequestAsync(_urlBuilder, _self, false);
        return _self;
      }

      _fireRequest(_urlBuilder, _self);
      return _self;
    };

    /*
     * Used by the server to signal that all assets have been loaded by
     * the browser.
     */
    mbox.prototype.loaded = function () {
      this.cancelTimeout();

      // To avoid a runaway timer, we will try to activate ONLY a specific number of times
      if (!this.activate() && this._activateCount < this._maxActivateCount) {
        var _self = this;

        setTimeout(function () {
          _self.loaded();
        }, TNT._internal._settings.mboxLoadedTimeout);
      }
    };

    /**
     * Called when the mbox has been successfully loaded to activate
     * the mbox for display.
     *
     * This call may fail if the DOM has not been fully constructed
     */
    mbox.prototype.activate = function () {
      if (this._activated) {
        return this._activated;
      }

      if (this._waitForNestedMboxes && this._nestedMboxes[this._nestedMboxes.length - 1] !== this._name) {
        return this._activated;
      }

      if (this.show()) {
        this.cancelTimeout();
        this._activated = 1;
      }

      if (this._waitForNestedMboxes) {
        this._nestedMboxes.pop();
      }

      return this._activated;
    };

    /**
     * @return true if the mbox has been successfully activated
     */
    mbox.prototype.isActivated = function () {
      return this._activated;
    };

    /**
     * Sets an offer into mbox.
     *
     * @param _offer Offer object that must have 'show(mbox)' method which
     * will be called to render this offer within the mbox passed in.
     *
     * The offer.show() method should return 1 on success and 0 on error.
     */
    mbox.prototype.setOffer = function (_offer) {
      var _offerExists = _offer && _offer.show && _offer.setOnLoad;

      if (!_offerExists) {
        throw 'Invalid offer';
      }

      var _shouldCopyOnLoad = TNT._internal._settings.globalMboxName === this._name;
      _shouldCopyOnLoad = _shouldCopyOnLoad && _offer instanceof mboxOfferDefault;
      _shouldCopyOnLoad = _shouldCopyOnLoad && this._contentFetcher !== null;
      _shouldCopyOnLoad = _shouldCopyOnLoad && this._contentFetcher.getType() === 'ajax';

      if (!_shouldCopyOnLoad) {
        this._offer = _offer;

        return this;
      }

      // The _onLoad will be copied ONLY when we have global mbox,
      // the content fetcher is of type AJAX
      // and the offer to be set is of type mboxDefaultOffer
      // in all other cases we will use the normal flow
      var _onLoadFunc = this._offer._onLoad;
      this._offer = _offer;

      this._offer.setOnLoad(_onLoadFunc);

      return this;
    };

    mbox.prototype.getOffer = function () {
      return this._offer;
    };

    /**
     * Shows the offer.
     *
     * @return 1 if it was possible to show the content, 0 otherwise.
     */
    mbox.prototype.show = function () {
      /* WDPRO Additions */
      var target;
      /* End WDPRO Additions */

      var result = this._offer.show(this);

      /* WDPRO Additions */
      // if callback function exists then call it
      if ('function' == typeof mbox.mboxShowCallback) {
        mbox.mboxShowCallback(result);
      }

      //if there was a TnT failure, make sure the target div is reshown
      if (result !== 1) {
        var mboxName = this.getName();
        if (tnt_wdpro.aMboxTargets[mboxName] && tnt_wdpro.aMboxTargets[mboxName] !== '') {
          target = tnt_wdpro.getElement(tnt_wdpro.aMboxTargets[mboxName]);
          tnt_wdpro.showMboxTargetDivs(mboxName, target);
        }
      }
      /* End WDPRO Additions */

      return result;
    };

    /**
     * Shows the specified content in the mbox.
     *
     * @return Number 1 if it was possible to show the content, 0 otherwise.
     */
    mbox.prototype.showContent = function (_content) {
      if (!mbox._isContentAvailable(_content)) {
        return 0;
      }

      this._div = mbox._getMarkerDivIfRequired(this, this._div);

      if (this._div === null) {
        return 0;
      }

      if (!mbox._containsNode(document.body, this._div)) {
        return 0;
      }

      if (this._div === _content) {
        this._showDiv(this._div);
        this._onLoad();
        return 1;
      }

      this._hideDiv(this._div);
      this._hideDiv(_content);

      mbox._replaceDiv(this, _content);

      this._showDiv(this._div);
      this._onLoad();

      return 1;
    };

    mbox._isContentAvailable = function (_content) {
      return _content !== undefined && _content !== null;
    };

    mbox._containsNode = function (_parent, _child) {
      var DOCUMENT_POSITION_CONTAINED_BY = 16;
      var _containsMethodExists = _parent.contains !== undefined;

      // Node.contains() is available in IE and some versions of Safari
      // some versions of FireFox do not have support for Node.contains()
      if (_containsMethodExists) {
        return _parent !== _child && _parent.contains(_child);
      } else {
        // w3c DOM Level 3 should be available in all modern browsers
        return Boolean(_parent.compareDocumentPosition(_child) & DOCUMENT_POSITION_CONTAINED_BY);
      }
    };

    mbox._getMarkerDivIfRequired = function (_mbox, _div) {
      if (_div !== undefined && _div !== null && mbox._containsNode(document.body, _div)) {
        return _div;
      }

      return _mbox.getDefaultDiv();
    };

    mbox._replaceDiv = function (_mbox, _newDiv) {
      _mbox._div.parentNode.replaceChild(_newDiv, _mbox._div);
      _mbox._div = _newDiv;
    };

    /**
     * Hides any fetched content and show Default Content associated
     * with the mbox if it is avaliable yet.
     *
     * @return Number if it was possible to show the default content
     */
    mbox.prototype.hide = function () {
      return this.showContent(this.getDefaultDiv());
    };

    /**
     * Puts the mbox into a shown state, if that fails shows default content
     * Also cancels any timeouts associated with the mbox
     */
    mbox.prototype.finalize = function () {
      if (!this.getDefaultDiv()) {
        this._locator.force();
      }

      if (!this.getDiv()) {
        this._div = mbox._getMarkerDivIfRequired(this, this._div);
      }

      this._disableWaitForNestedMboxes();
      this.setFetcher(new mboxAjaxFetcher());
      this.cancelTimeout();
      this._onLoad();
    };

    mbox.prototype.cancelTimeout = function () {
      if (this._timer) {
        clearTimeout(this._timer);
      }

      if (this._contentFetcher) {
        this._contentFetcher.cancel();
      }
    };

    mbox.prototype.getDiv = function () {
      return this._div;
    };

    /**
     * returns valid default div
     * (even if it's not present in the DOM anymore)
     */
    mbox.prototype.getDefaultDiv = function () {
      if (this._defaultDiv === null) {
        this._defaultDiv = this._locator.locate();
      }
      return this._defaultDiv;
    };

    mbox.prototype.setEventTime = function (_event) {
      this._times[_event] = new Date().getTime();
    };

    mbox.prototype.getEventTimes = function () {
      return this._times;
    };

    mbox.prototype.getImportName = function () {
      return this._importName;
    };

    mbox.prototype.getURL = function () {
      return this._urlBuilder.buildUrl();
    };

    mbox.prototype.getUrlBuilder = function () {
      return this._urlBuilder;
    };

    mbox.prototype._isVisible = function (_div) {
      return _div.style.display != 'none';
    };

    mbox.prototype._showDiv = function (_div) {
      this._toggleDiv(_div, true);
    };

    mbox.prototype._hideDiv = function (_div) {
      this._toggleDiv(_div, false);
    };

    mbox.prototype._toggleDiv = function (_div, _visible) {
      _div.style.visibility = _visible ? "visible" : "hidden";
      _div.style.display = _visible ? "block" : "none";
    };

    mbox.prototype._disableWaitForNestedMboxes = function () {
      this._waitForNestedMboxes = false;
    };

    mbox.prototype.relocateDefaultDiv = function () {
      this._defaultDiv = this._locator.locate();
    };

    /**
     * Creates and updates mboxes.
     *
     * @param _server host of the mbox server e.g.mbox-test.dev.tt.omtrdc.net
     * @param _clientCode - client's code e.g. 'demo'
     * @param _factoryId - a unique string identifying this factory
     */

    function _finalize(_factory) {
      _factory.getMboxes().each(function (_mbox) {
        _mbox.finalize();
      });
    }

    mboxFactory = function mboxFactory(_server, _clientCode, _factoryId) {
      var _context = TNT._internal;
      var _settings = _context._settings;
      var _helper = _context._helper;
      var _cookies = _context._cookies;
      var _pageParams = _context._pageParams;
      var _constants = _context._constants;
      var _version = _settings.mboxVersion;

      this._pageLoaded = false;
      this._factoryId = _factoryId;
      this._mboxes = new mboxList();

      mboxFactories.put(_factoryId, this);

      // mboxIsSupported is a client defined function to test if mbox is supported
      // on this platform (defaults to just returning true)
      this._supported = _settings.mboxIsSupportedFunction() && typeof (window.attachEvent || document.addEventListener || window.addEventListener) != 'undefined';

      this._enabled = this._supported && mboxGetPageParameter(_pageParams._disable, true) === null;

      var _isDefaultFactory = _factoryId == _constants._defaultFactoryId;
      var _cookieName = _constants._cookieNamePrefix + (_isDefaultFactory ? '' : '-' + _factoryId);
      this._cookieManager = new mboxCookieManager(_cookieName, _settings.cookieDomainFunction());

      if (!_settings.crossDomainXOnly) {
        this._enabled = this._enabled && this._cookieManager.isEnabled();
      }

      this._enabled = this._enabled && _helper._isNull(this._cookieManager.getCookie(_cookies._disable)) && _helper._isNull(this._cookieManager.getCookie(_cookies._experienceManagerDisabled));

      if (this.isAdmin()) {
        this.enable();
      }

      this._listenForDomReady();
      this._mboxPageId = mboxGenerateId();
      this._mboxScreenHeight = mboxScreenHeight();
      this._mboxScreenWidth = mboxScreenWidth();
      this._mboxBrowserWidth = mboxBrowserWidth();
      this._mboxBrowserHeight = mboxBrowserHeight();
      this._mboxColorDepth = mboxScreenColorDepth();
      this._mboxBrowserTimeOffset = mboxBrowserTimeOffset();
      this._mboxSessionId = new mboxSession(this._mboxPageId, _pageParams._sessionId, _cookies._sessionId, _settings.sessionExpirationTimeout, this._cookieManager);

      var _pc = new mboxPC(_cookies._tntId, _settings.tntIdLifetime, this._cookieManager);

      this._mboxPCId = _settings.overrideMboxEdgeServer ? new _context._pcDecorator(_pc, this._cookieManager) : _pc;
      this._urlBuilder = new mboxUrlBuilder(_server, _clientCode);

      this._initGlobalParameters(this._urlBuilder, _isDefaultFactory, _version);

      this._pageStartTime = new Date().getTime();
      this._pageEndTime = this._pageStartTime;

      var _self = this;
      this.addOnLoad(function () {
        _self._pageEndTime = new Date().getTime();
      });

      if (this._supported) {
        // Checks that all mboxes have been successfully imported
        // and shows default content for any that failed
        this.addOnLoad(function () {
          _self._pageLoaded = true;

          _finalize(_self);

          TNT._internal.nestedMboxes = [];
        });

        if (this._enabled) {
          this.limitTraffic(_settings.trafficLevelPercentage, _settings.trafficDuration);
          this._makeDefaultContentInvisible();
          this._mboxSignaler = new mboxSignaler(this);
        } else {
          if (!_settings.isProduction) {
            if (this.isAdmin()) {
              if (!this.isEnabled()) {
                alert("mbox disabled, probably due to timeout\n" + "Reset your cookies to re-enable\n(this message will only appear in administrative mode)");
              } else {
                alert("It looks like your browser will not allow " + _settings.companyName + " to set its administrative cookie. To allow setting the" + " cookie please lower the privacy settings of your browser.\n" + "(this message will only appear in administrative mode)");
              }
            }
          }
        }
      }
    };

    /**
     * Forcibly sets new PC ID.
     * This method should be used when there is a better way to track
     * a site user than by PC ID.
     *
     * @param _forcedId New PC ID to set.
     */
    mboxFactory.prototype.forcePCId = function (_forcedId) {
      if (!TNT._internal._settings.clientTntIdSupport) {
        return;
      }

      if (this._mboxPCId.forceId(_forcedId)) {
        this._mboxSessionId.forceId(mboxGenerateId());
      }
    };

    /**
     * Allows the client to use their sessionId as the mbox sessionId. This
     * is useful if the client is required to preserve their id through their
     * site.
     *
     * @param sessionId for New session id.
     */
    mboxFactory.prototype.forceSessionId = function (_forcedId) {
      if (!TNT._internal._settings.clientSessionIdSupport) {
        return;
      }

      this._mboxSessionId.forceId(_forcedId);
    };

    /**
     * @return true if the factory is enabled. If factory is disabled, the mboxes
     * are still created but they show default content only.
     */
    mboxFactory.prototype.isEnabled = function () {
      return this._enabled;
    };

    /**
     * @return cause of mbox disabling
     */
    mboxFactory.prototype.getDisableReason = function () {
      return this._cookieManager.getCookie(TNT._internal._cookies._disable);
    };

    /**
     * @return true if the client's environment is supported (i.e. there's a way
     *   to access DOM elements via document.getElementById and event handling
     *   is supported)
     */
    mboxFactory.prototype.isSupported = function () {
      return this._supported;
    };

    /**
     * Disables the factory for the specified duration.
     *
     * @param _duration - duration in seconds (optional)
     * @param _cause - cause of disable (optional)
     */
    mboxFactory.prototype.disable = function (_duration, _cause) {
      if (typeof _duration == 'undefined') {
        _duration = 60 * 60;
      }

      if (typeof _cause == 'undefined') {
        _cause = 'unspecified';
      }

      if (!this.isAdmin()) {
        this._enabled = false;
        this._cookieManager.setCookie(TNT._internal._cookies._disable, _cause, _duration);
      }
    };

    mboxFactory.prototype.enable = function () {
      this._enabled = true;
      this._cookieManager.deleteCookie(TNT._internal._cookies._disable);
    };

    mboxFactory.prototype.isAdmin = function () {
      return document.location.href.indexOf(TNT._internal._pageParams._environment) != -1;
    };

    /**
     * Limits the traffic (by disabling the factory for certain users) to the given
     * level for the specified duration.
     */
    mboxFactory.prototype.limitTraffic = function (_level, _duration) {
      if (TNT._internal._settings.trafficLevelPercentage != 100) {
        if (_level == 100) {
          return;
        }

        var _enable = true;

        if (parseInt(this._cookieManager.getCookie(TNT._internal._cookies._trafficLevel)) != _level) {
          _enable = Math.random() * 100 <= _level;
        }

        this._cookieManager.setCookie(TNT._internal._cookies._trafficLevel, _level, _duration);

        if (!_enable) {
          this.disable(60 * 60, 'limited by traffic');
        }
      }
    };

    /**
     * Adds a function to be called with body onload.
     */
    mboxFactory.prototype.addOnLoad = function (_function) {

      // This extra checking is so that if there is a race, where addOnLoad
      // is called as the onload functions are being called, we'll detect this
      // and correctly call the passed in function exactly once, after the dom
      // has loaded.

      if (this.isDomLoaded()) {
        _function();
      } else {
        var _calledFunction = false;
        var _wrapper = function _wrapper() {
          if (_calledFunction) {
            return;
          }
          _calledFunction = true;
          _function();
        };

        this._onloadFunctions.push(_wrapper);

        if (this.isDomLoaded() && !_calledFunction) {
          _wrapper();
        }
      }
    };

    mboxFactory.prototype.getEllapsedTime = function () {
      return this._pageEndTime - this._pageStartTime;
    };

    mboxFactory.prototype.getEllapsedTimeUntil = function (_time) {
      return _time - this._pageStartTime;
    };

    /**
     * @return An mboxList object that contains the mboxes associated with this
     *   factory.
     */
    mboxFactory.prototype.getMboxes = function () {
      return this._mboxes;
    };

    /**
     * @param _mboxId the id of the mbox, defaults to 0 if not specified.
     *
     * @return mbox with the specified _mboxName and _mboxId.
     */
    mboxFactory.prototype.get = function (_mboxName, _mboxId) {
      return this._mboxes.get(_mboxName).getById(_mboxId || 0);
    };

    /**
     * Updates one or more mboxes with the name _mboxName
     *
     * @param _mboxName - name of the mbox
     * @param _parameters - array of 0 or more items of the form "name=value"
     *   (the values need to be escaped for inclusion in the url)
     */
    mboxFactory.prototype.update = function (_mboxName, _parameters) {
      var _context = TNT._internal,
          _params = _context._params;

      if (!this.isEnabled()) {
        return;
      }

      var _self = this;

      if (!this.isDomLoaded()) {
        this.addOnLoad(function () {
          _self.update(_mboxName, _parameters);
        });

        return;
      }

      if (this._mboxes.get(_mboxName).length() === 0) {
        throw "Mbox " + _mboxName + " is not defined";
      }

      this._mboxes.get(_mboxName).each(function (_mbox) {
        var _urlBuilder = _mbox.getUrlBuilder();

        _urlBuilder.addParameter(_params._page, mboxGenerateId());

        _self._addMboxParameters(_urlBuilder, _mboxName);

        _mbox.load(_parameters);
      });
    };

    /**
     * This is a dummy method that we'll have to remove, all the logic is now part of Visitor API plugin
     */
    mboxFactory.prototype.setVisitorIdParameters = function (_urlBuilder, _mboxName) {
      this._addMboxParameters(_urlBuilder, _mboxName);
    };

    /**
     * Creates an mbox called _mboxName.
     *
     * There is a small chance that an mbox with the same name is created after
     * we call update - we will ignore this chance.
     *
     * @param _mboxName - name of the mbox
     * @param _parameters - array of 0 or more items of the form "name=value"
     *   (the values need to be escaped for inclusion in the url)
     * @param _defaultNode - the DOM node that is the default content
     *                       the name of the DOM that is the default content
     *                       or is not specified, search bacwords for
     *                       mboxDefault class to use as default content
     */
    mboxFactory.prototype.create = function (_mboxName, _parameters, _defaultNode) {
      return this._createMbox(_mboxName, _parameters, _defaultNode);
    };

    /**
     * This method will be used ONLY in mboxDefine()
     *
     * @param _mboxName
     * @param _parameters
     * @param _defaultNode
     * @private
     */
    mboxFactory.prototype._define = function (_mboxName, _parameters, _defaultNode) {
      return this._createMbox(_mboxName, _parameters, _defaultNode);
    };

    mboxFactory.prototype._createMbox = function (_mboxName, _parameters, _defaultNode) {
      if (!this.isSupported()) {
        return null;
      }

      var _now = new Date();
      var _time = _now.getTime() - _now.getTimezoneOffset() * TNT._internal._constants._millisInMinute;
      var _urlBuilder = this._urlBuilder.clone();

      _urlBuilder.addParameter(TNT._internal._params._count, this._mboxes.length() + 1);
      _urlBuilder.addParameter(TNT._internal._params._time, _time);
      _urlBuilder.addParameters(_parameters);

      this._addMboxParameters(_urlBuilder, _mboxName);

      var _mboxId, _locator, _mbox;

      if (_defaultNode) {
        _locator = new mboxLocatorNode(_defaultNode);
      } else {
        if (this._pageLoaded) {
          throw 'The page has already been loaded, can\'t write marker';
        }

        _locator = new mboxLocatorDefault(this._getMboxMarkerDivId(_mboxName));
      }

      try {
        _mboxId = this._mboxes.get(_mboxName).length();
        _mbox = new mbox(_mboxName, _mboxId, _urlBuilder, _locator, this._getMboxImportDivId(_mboxName), this);

        if (this._enabled) {
          _mbox.setFetcher(this._pageLoaded ? new mboxAjaxFetcher() : new mboxStandardFetcher());
        }

        var _self = this;

        _mbox.setOnError(function (_message, _type) {
          _mbox.setMessage(_message);
          _mbox.activate();

          if (!_mbox.isActivated()) {
            _self.disable(TNT._internal._settings.mboxFactoryDisabledTimeout, _message);
            window.location.reload(false);
          }
        });

        this._mboxes.add(_mbox);
      } catch (_e) {
        this.disable();
        throw 'Failed creating mbox "' + _mboxName + '", the error was: ' + _e;
      }

      return _mbox;
    };

    mboxFactory.prototype._addTntIdIfExists = function (_urlBuilder) {
      var _tntId = this._mboxPCId.getId();

      if (_tntId) {
        _urlBuilder.addParameter(TNT._internal._params._tntId, _tntId);
      }
    };

    mboxFactory.prototype._addTargetPageParamsIfExists = function (_urlBuilder, _mboxName) {
      var _shouldAddParams = !TNT.isAutoCreateGlobalMbox() && TNT.getGlobalMboxName() === _mboxName;

      if (_shouldAddParams) {
        _urlBuilder.addParameters(TNT.getTargetPageParameters());
      }
    };

    mboxFactory.prototype._addSupplementalDataIfExists = function (_urlBuilder, _mboxName) {
      var _context = TNT._internal,
          _supplementalDataIdParam = _context._params._supplementalDataId,
          _supplementalDataId = _context._generateSupplementalDataId(_mboxName);

      // According to Visitor API folks we have to regenerate supplemental data ID
      // when mboxUpdate is invoked
      if (_supplementalDataId) {
        _urlBuilder.addParameter(_supplementalDataIdParam, _supplementalDataId);
      }
    };

    mboxFactory.prototype._addMarketingCloudDataIfExists = function (_urlBuilder) {
      var _context = TNT._internal;

      if (_context._isVisitorApiAvailable() && _context._isMarketingCloudDataAvailable()) {
        _urlBuilder.addParameters(_context._getMarketingCloudData());
      }
    };

    mboxFactory.prototype._addMboxParameters = function (_urlBuilder, _mboxName) {
      this._addTntIdIfExists(_urlBuilder);
      this._addTargetPageParamsIfExists(_urlBuilder, _mboxName);
      this._addSupplementalDataIfExists(_urlBuilder, _mboxName);
      this._addMarketingCloudDataIfExists(_urlBuilder, _mboxName);
    };

    mboxFactory.prototype.getCookieManager = function () {
      return this._cookieManager;
    };

    mboxFactory.prototype.getPageId = function () {
      return this._mboxPageId;
    };

    mboxFactory.prototype.getPCId = function () {
      return this._mboxPCId;
    };

    mboxFactory.prototype.getSessionId = function () {
      return this._mboxSessionId;
    };

    mboxFactory.prototype.getSignaler = function () {
      return this._mboxSignaler;
    };

    mboxFactory.prototype.getUrlBuilder = function () {
      return this._urlBuilder;
    };

    mboxFactory.prototype._getMboxDivSuffix = function (_mboxName) {
      return this._factoryId + '-' + _mboxName + '-' + this._mboxes.get(_mboxName).length();
    };

    mboxFactory.prototype._getMboxMarkerDivId = function (_mboxName) {
      return TNT._internal._constants._divMarkerPrefix + this._getMboxDivSuffix(_mboxName);
    };

    mboxFactory.prototype._getMboxImportDivId = function (_mboxName) {
      return TNT._internal._constants._divImportPrefix + this._getMboxDivSuffix(_mboxName);
    };

    mboxFactory.prototype._initGlobalParameters = function (_urlBuilder, _isDefaultFactory, _version) {
      _urlBuilder.addParameter(TNT._internal._params._host, document.location.hostname);
      _urlBuilder.addParameter(TNT._internal._params._page, this._mboxPageId);
      _urlBuilder.addParameter(TNT._internal._params._screenHeight, this._mboxScreenHeight);
      _urlBuilder.addParameter(TNT._internal._params._screenWidth, this._mboxScreenWidth);
      _urlBuilder.addParameter(TNT._internal._params._browserWidth, this._mboxBrowserWidth);
      _urlBuilder.addParameter(TNT._internal._params._browserHeight, this._mboxBrowserHeight);
      _urlBuilder.addParameter(TNT._internal._params._browserTimeOffset, this._mboxBrowserTimeOffset);
      _urlBuilder.addParameter(TNT._internal._params._screenColorDepth, this._mboxColorDepth);
      _urlBuilder.addParameter(TNT._internal._pageParams._sessionId, this._mboxSessionId.getId());

      if (!_isDefaultFactory) {
        _urlBuilder.addParameter(TNT._internal._params._mboxFactoryId, this._factoryId);
      }

      if (TNT._internal._settings.crossDomainEnabled) {
        _urlBuilder.addParameter(TNT._internal._params._crossDomain, TNT._internal._settings.crossDomain);
      }

      var _params = TNT.getClientMboxExtraParameters();

      if (_params) {
        _urlBuilder.addParameters(_params.split('&'));
      }

      _urlBuilder.setUrlProcessAction(function (_url) {
        if (TNT._internal._settings.passPageParameters) {
          _url += '&';
          _url += TNT._internal._params._url;
          _url += '=' + encodeURIComponent(document.location);

          var _referrer = encodeURIComponent(document.referrer);

          if (_url.length + _referrer.length < 2000) {
            _url += '&';
            _url += TNT._internal._params._referrer;
            _url += '=' + _referrer;
          }
        }

        _url += '&';
        _url += TNT._internal._params._mboxVersion;
        _url += '=' + _version;

        return _url;
      });
    };

    /**
     * Causes all mbox default content to not be displayed:
     */
    mboxFactory.prototype._makeDefaultContentInvisible = function () {
      document.write('<style>.' + TNT._internal._constants._divDefaultClass + ' { visibility:hidden; }</style>');
    };

    mboxFactory.prototype.isDomLoaded = function () {
      return this._pageLoaded;
    };

    mboxFactory.prototype._listenForDomReady = function () {
      if (this._onloadFunctions) {
        return;
      }

      this._onloadFunctions = [];

      var _self = this;
      (function () {
        var _eventName = document.addEventListener ? "DOMContentLoaded" : "onreadystatechange";
        var _loaded = false;
        var _ready = function _ready() {
          if (_loaded) {
            return;
          }
          _loaded = true;
          for (var i = 0; i < _self._onloadFunctions.length; ++i) {
            _self._onloadFunctions[i]();
          }
        };

        if (document.addEventListener) {
          document.addEventListener(_eventName, function () {
            document.removeEventListener(_eventName, arguments.callee, false);
            _ready();
          }, false);

          window.addEventListener("load", function () {
            document.removeEventListener("load", arguments.callee, false);
            _ready();
          }, false);
        } else if (document.attachEvent) {
          if (self !== self.top) {
            document.attachEvent(_eventName, function () {
              if (document.readyState === 'complete') {
                document.detachEvent(_eventName, arguments.callee);
                _ready();
              }
            });
          } else {
            var _checkScrollable = function _checkScrollable() {
              try {
                document.documentElement.doScroll('left');
                _ready();
              } catch (_domNotReady) {
                setTimeout(_checkScrollable, 13);
              }
            };
            _checkScrollable();
          }
        }

        if (document.readyState === "complete") {
          _ready();
        }
      })();
    };

    (function (_module) {
      function _disableExperienceManagerAndReload(_atObj, _cookieName, _duration, _cookieManager) {
        if (_atObj.targetJSLoaded) {
          return;
        }

        _cookieManager.setCookie(_cookieName, true, _duration);
        window.location.reload();
      }

      function _initExperienceManager(_settings, _cookies, _cookieManager) {
        var _AT_KEY = '_AT',
            _RETRY = 50,
            _cookieName = _cookies._experienceManagerDisabled,
            _duration = _settings.experienceManagerDisabledTimeout,
            _timeout = _settings.experienceManagerTimeout,
            _url = _settings.experienceManagerPluginUrl,
            _emptyFunc = function _emptyFunc(_actions) {},
            _dummyFunc = function _dummyFunc(_actions) {
          setTimeout(function () {
            window[_AT_KEY].applyWhenReady(_actions);
          }, _RETRY);
        };

        if (_AT_KEY in window) {
          return;
        }

        window[_AT_KEY] = {};

        if (_cookieManager.getCookie(_cookieName) !== 'true') {
          document.write('<scr' + 'ipt src="' + _url + '"><\/sc' + 'ript>');

          window[_AT_KEY].applyWhenReady = _dummyFunc;

          setTimeout(function () {
            _disableExperienceManagerAndReload(window[_AT_KEY], _cookieName, _duration, _cookieManager);
          }, _timeout);
        } else {
          window[_AT_KEY].applyWhenReady = _emptyFunc;
        }
      }

      _module._initExperienceManager = _initExperienceManager;
    })(TNT._internal);

    (function (_module, _internal, _helper, _settings, _params, _constants) {
      function _getGlobalMboxName() {
        return _settings.globalMboxName;
      }

      function _getGlobalMboxLocation() {
        return _settings.globalMboxLocationDomId;
      }

      function _isAutoCreateGlobalMbox() {
        return _settings.globalMboxAutoCreate;
      }

      function _getClientMboxExtraParameters() {
        return _settings.parametersFunction();
      }

      function _getMboxDefaultNode() {
        var _ELEMENT_NODE = 1,
            _nodes = document.getElementsByTagName('script'),
            _node = _nodes[_nodes.length - 1];

        while (_node) {
          if (_node.nodeType === _ELEMENT_NODE && _node.className === _constants._divDefaultClass) {
            return _node;
          }

          _node = _node.previousSibling;
        }

        return null;
      }

      function _mboxCreate(_factory, _mboxName, _params) {
        var _defaultNode, _mbox;

        if (_internal._isVisitorApiAvailable()) {
          _defaultNode = _getMboxDefaultNode();
          _mbox = _factory.create(_mboxName, _params, _defaultNode);
        } else {
          _mbox = _factory.create(_mboxName, _params);
        }

        if (_mbox && _factory.isEnabled()) {
          _mbox.load();
        }

        return _mbox;
      }

      function _mboxDefine(_factory, _defaultNode, _mboxName, _params) {
        return _factory._define(_mboxName, _params, _defaultNode);
      }

      function _mboxUpdate(_factory, _mboxName, _params) {
        _factory.update(_mboxName, _params);
      }

      function _mboxGetCookie(_cookieManager, _name) {
        return _cookieManager.getCookie(_name);
      }

      function _mboxSetCookie(_cookieManager, _name, _value, _duration) {
        _cookieManager.setCookie(_name, _value, _duration);
      }

      function _extractParamsFromQueryString(_queryString) {
        var _result = [];
        var _regex = /([^&=]+)=([^&]*)/g;
        var _decode = decodeURIComponent;
        var _match = _regex.exec(_queryString);

        while (_match) {
          _result.push([_decode(_match[1]), _decode(_match[2])].join('='));
          _match = _regex.exec(_queryString);
        }

        return _result;
      }

      function _extractParamsFromObject(_obj, _keys, _keyFunc) {
        var _result = [];

        for (var _key in _obj) {
          if (!_obj.hasOwnProperty(_key)) {
            continue;
          }

          var _value = _obj[_key];

          if (_helper._isObject(_value)) {
            _keys.push(_key);
            _result = _result.concat(_extractParamsFromObject(_value, _keys, _keyFunc));
            _keys.pop();
          } else {
            if (_keys.length > 0) {
              _result.push([_keyFunc(_keys.concat(_key).join('.')), _value].join('='));
            } else {
              _result.push([_keyFunc(_key), _value].join('='));
            }
          }
        }

        return _result;
      }

      function _getTargetPageParameters() {
        var _targetPageParams = window.targetPageParams,
            _keyFunc = function _keyFunc(_key) {
          return _key;
        };

        if (!_helper._isFunction(_targetPageParams)) {
          return [];
        }

        var _result = null;

        try {
          _result = _targetPageParams();
        } catch (_ignore) {}

        if (_helper._isNull(_result)) {
          return [];
        }

        if (_helper._isArray(_result)) {
          return _result;
        }

        if (_helper._isString(_result) && !_helper._isEmpty(_result)) {
          return _extractParamsFromQueryString(_result);
        }

        if (_helper._isObject(_result)) {
          return _extractParamsFromObject(_result, [], _keyFunc);
        }

        return [];
      }

      function _createGlobalMbox(_factory) {
        var _globalMboxName = _getGlobalMboxName(),
            _globalMboxDomElementId = _getGlobalMboxLocation(),
            _globalParams = _getTargetPageParameters(),
            _globalMboxDiv,
            _timerId,
            _globalMbox;

        if (!_globalMboxDomElementId) {
          _globalMboxDomElementId = "mbox-" + _globalMboxName + "-" + mboxGenerateId();
          _globalMboxDiv = document.createElement("div");
          _globalMboxDiv.className = "mboxDefault";
          _globalMboxDiv.id = _globalMboxDomElementId;
          _globalMboxDiv.style.visibility = "hidden";
          _globalMboxDiv.style.display = "none";

          _timerId = setInterval(function () {
            if (document.body) {
              clearInterval(_timerId);
              document.body.insertBefore(_globalMboxDiv, document.body.firstChild);
            }
          }, _settings.bodyPollingTimeout);
        }

        _globalMbox = _factory.create(_globalMboxName, _globalParams, _globalMboxDomElementId);

        if (_globalMbox && _factory.isEnabled()) {
          if (!_factory.isDomLoaded()) {
            if (!_internal._isVisitorApiAvailable()) {
              _globalMbox.setFetcher(new _internal._globalMboxFetcher());
            } else if (_internal._isMarketingCloudDataAvailable()) {
              _globalMbox.setFetcher(new _internal._globalMboxFetcher());
            } else {
              _globalMbox.setFetcher(new mboxAjaxFetcher());
            }
          }

          _globalMbox.load();
        }
      }

      function _mboxVizTargetUrl(_factory, _mboxName, _parameters) {
        if (!_factory.isEnabled()) {
          return;
        }

        var _now = new Date(),
            _offset = _now.getTimezoneOffset() * _constants._millisInMinute,
            _urlBuilder = _factory.getUrlBuilder().clone();

        _urlBuilder.setBasePath('/m2/' + _settings.clientCode + '/viztarget');
        _urlBuilder.addParameter(_params._mboxName, _mboxName);
        _urlBuilder.addParameter(_params._mboxId, 0);
        _urlBuilder.addParameter(_params._count, _factory.getMboxes().length() + 1);
        _urlBuilder.addParameter(_params._time, _now.getTime() - _offset);
        _urlBuilder.addParameter(_params._page, mboxGenerateId());
        _urlBuilder.addParameter(_params._domLoaded, _factory.isDomLoaded());

        if (_parameters && _parameters.length > 0) {
          _urlBuilder.addParameters(_parameters);
        }

        _factory._addTntIdIfExists(_urlBuilder);
        _factory._addTargetPageParamsIfRequired(_urlBuilder, _mboxName);
        _factory._addSupplementalDataIfExists(_urlBuilder, _mboxName);

        return _urlBuilder.buildUrl();
      }

      function _createMboxFactories() {
        return new mboxMap();
      }

      function _createMboxFactory(_serverHost, _clientCode, _factoryId) {
        return new mboxFactory(_serverHost, _clientCode, _factoryId);
      }

      // internally exported
      _internal._mboxCreate = _mboxCreate;
      _internal._mboxDefine = _mboxDefine;
      _internal._mboxUpdate = _mboxUpdate;
      _internal._mboxVizTargetUrl = _mboxVizTargetUrl;
      _internal._mboxGetCookie = _mboxGetCookie;
      _internal._mboxSetCookie = _mboxSetCookie;
      _internal._createGlobalMbox = _createGlobalMbox;
      _internal._createMboxFactories = _createMboxFactories;
      _internal._createMboxFactory = _createMboxFactory;
      _internal._extractParamsFromObject = _extractParamsFromObject;

      // globally exported
      _module.getGlobalMboxName = _getGlobalMboxName;
      _module.getGlobalMboxLocation = _getGlobalMboxLocation;
      _module.isAutoCreateGlobalMbox = _isAutoCreateGlobalMbox;
      _module.getClientMboxExtraParameters = _getClientMboxExtraParameters;
      _module.getTargetPageParameters = _getTargetPageParameters;
    })(TNT, TNT._internal, TNT._internal._helper, TNT._internal._settings, TNT._internal._params, TNT._internal._constants);

    (function (_module) {
      function _showDebugInfoIfRequired(_cookieManager, _settings, _debugParam, _debugCookie) {
        var _DEBUG_TIMEOUT = 60 * 60,
            _isDebugEnabled = mboxGetPageParameter(_debugParam, true) || _cookieManager.getCookie(_debugCookie);

        if (!_isDebugEnabled) {
          return;
        }

        setTimeout(function () {
          if (typeof window.mboxDebugLoaded === 'undefined') {
            alert('Could not load the remote debug.\nPlease check your connection to ' + _settings.companyName + ' servers');
          }
        }, _DEBUG_TIMEOUT);

        var _parts = [];

        _parts.push(_settings.adminUrl, '/mbox/mbox_debug.jsp', '?');
        _parts.push('mboxServerHost', '=', _settings.serverHost, '&');
        _parts.push('clientCode', '=', _settings.clientCode);

        document.write('<' + 'scr' + 'ipt src="' + _parts.join('') + '"><' + '\/scr' + 'ipt>');
      }

      function _copySettingsIfExists(_settings, _internalSettings) {
        var _helper = _module._helper,
            _keyExists,
            _valueExists,
            _value;

        if (_helper._isUndefined(_settings) || _helper._isNull(_settings) || !_helper._isObject(_settings)) {
          return _internalSettings;
        }

        for (var _key in _settings) {
          _keyExists = _settings.hasOwnProperty(_key) && _internalSettings.hasOwnProperty(_key);
          _value = _settings[_key];
          _valueExists = !_helper._isUndefined(_value) && !_helper._isNull(_value);

          if (_keyExists && _valueExists) {
            _internalSettings[_key] = _value;
          }
        }

        return _internalSettings;
      }

      function _exportGlobals(_factory, _cookieManager) {
        TNT.createGlobalMbox = function () {
          _module._createGlobalMbox(_factory);
        };

        window.mboxCreate = function (_mboxName /*, ...*/) {
          var _params = [].slice.call(arguments, 1);

          return _module._mboxCreate(_factory, _mboxName, _params);
        };

        window.mboxDefine = function (_defaultNode, _mboxName /*, ...*/) {
          var _params = [].slice.call(arguments, 2);

          return _module._mboxDefine(_factory, _defaultNode, _mboxName, _params);
        };

        window.mboxUpdate = function (_mboxName /*, ...*/) {
          var _params = [].slice.call(arguments, 1);

          _module._mboxUpdate(_factory, _mboxName, _params);
        };

        window.mboxVizTargetUrl = function (_mboxName /*, ...*/) {
          var _params = [].slice.call(arguments, 1);

          return _module._mboxVizTargetUrl(_factory, _mboxName, _params);
        };

        window.mboxSetCookie = function (_name, _value, _duration) {
          return _module._mboxSetCookie(_cookieManager, _name, _value, _duration);
        };

        window.mboxGetCookie = function (_name) {
          return _module._mboxGetCookie(_cookieManager, _name);
        };

        // In case SiteCatalyst integration is not enabled we should not
        // export the mboxLoadSCPlugin function
        if (typeof _module._mboxLoadSCPlugin !== 'undefined') {
          window.mboxLoadSCPlugin = function (_siteCatalystCore) {
            return _module._mboxLoadSCPlugin(_factory, _siteCatalystCore);
          };
        }
      }

      function _bootstrap() {
        if (typeof window.mboxVersion !== 'undefined') {
          return;
        }

        _module._settings = _copySettingsIfExists(window.targetGlobalSettings, _module._settings);

        var _settings = _module._settings,
            _version = _settings.mboxVersion,
            _serverHost = _settings.serverHost,
            _clientCode = _settings.clientCode,
            _defaultFactoryId = _module._constants._defaultFactoryId,
            _debugParam = _module._pageParams._debug,
            _debugCookie = _module._cookies._debug,
            _mboxEdgeServerCookie = _module._cookies._mboxEdgeServer,
            _factory,
            _cookieManager;

        // We should expose these variables to make sure other JS parts have access to them
        window.mboxFactories = _module._createMboxFactories();
        window.mboxFactoryDefault = _factory = _module._createMboxFactory(_serverHost, _clientCode, _defaultFactoryId);
        window.mboxVersion = _version;

        _cookieManager = _factory.getCookieManager();

        _exportGlobals(_factory, _cookieManager);
        _showDebugInfoIfRequired(_cookieManager, _settings, _debugParam, _debugCookie);

        _module._getMboxEdgeServer = function (_mboxServerDefaultValue) {
          var _mboxServer;

          if (!_settings.overrideMboxEdgeServer) {
            return _mboxServerDefaultValue;
          }

          _mboxServer = _cookieManager.getCookie(_mboxEdgeServerCookie);

          return _mboxServer === null ? _mboxServerDefaultValue : _mboxServer;
        };
      }

      _module._bootstrap = _bootstrap;
    })(TNT._internal);

    TNT._internal._bootstrap();

    TNT._internal._initExperienceManager(TNT._internal._settings, TNT._internal._cookies, window.mboxFactoryDefault.getCookieManager());
    /*mboxTrack() & mboxTrackLink() & mboxTrackDefer() v4 ==>Mbox.js Extra Javascript*/var mboxTrack = function mboxTrack(mbox, params) {
      var m,
          u,
          i,
          f = mboxFactoryDefault;if (f.isEnabled()) {
        if (f.getMboxes().length() > 0) {
          m = f.getMboxes().getById(0);u = m.getURL().replace("mbox=" + escape(m.getName()), "mbox=" + mbox).replace("/undefined", "/ajax").replace("mboxPage=" + f.getPageId(), "mboxPage=" + mboxGenerateId()) + '&' + params, i = new Image();i.style.display = 'none';i.src = u;document.body.appendChild(i);
        } else {
          mboxTrackDefer(mbox, params);
        }
      }
    },
        mboxTrackDefer = function mboxTrackDefer(mbox, params) {
      var f = mboxFactoryDefault;if (f.isEnabled()) {
        mboxFactoryDefault.getSignaler().signal(mbox, mbox + '&' + params);
      }
    },
        mboxTrackLink = function mboxTrackLink(mbox, params, url) {
      mboxTrack(mbox, params);setTimeout("location='" + url + "'", 500);
    };

    if (TNT.isAutoCreateGlobalMbox()) {
      TNT.createGlobalMbox();
    }

    [["_finalize", _finalize], ["_fireRequest", _fireRequest], ["_fireRequestAsync", _fireRequestAsync], ["_showMbox", _showMbox], ["mboxCopyright", mboxCopyright], ["mboxTrack", mboxTrack], ["mboxTrackDefer", mboxTrackDefer], ["mboxTrackLink", mboxTrackLink], ["TNT", TNT], ["tnt_wdpro", tnt_wdpro]].forEach(function (arr) {
      window[arr[0]] = arr[1];
    });
  })();
})(window);
//# sourceMappingURL=framework-top.js.map
